// This file is auto-generated by @hey-api/openapi-ts

import * as v from 'valibot';

export const vConnectMapsApiClientContractsDtosPathLevel = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  name: v.optional(v.union([v.string(), v.null()])),
  versionId: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsApiClientContractsDtosPersonInfo = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  firstName: v.optional(v.union([v.string(), v.null()])),
  lastName: v.optional(v.union([v.string(), v.null()])),
  email: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsApiClientContractsDtosConnectFile = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  name: v.optional(v.union([v.string(), v.null()])),
  type: v.optional(v.union([v.string(), v.null()])),
  versionId: v.optional(v.union([v.string(), v.null()])),
  parentId: v.optional(v.union([v.string(), v.null()])),
  createdBy: v.optional(vConnectMapsApiClientContractsDtosPersonInfo),
  modifiedBy: v.optional(vConnectMapsApiClientContractsDtosPersonInfo),
  thumbnailUrl: v.optional(v.union([v.array(v.string()), v.null()])),
  size: v.optional(v.union([v.string(), v.null()])),
  projectId: v.optional(v.union([v.string(), v.null()])),
  createdOn: v.optional(v.union([v.string(), v.null()])),
  modifiedOn: v.optional(v.union([v.string(), v.null()])),
  hash: v.optional(v.union([v.string(), v.null()])),
  revision: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(v.union([v.string(), v.null()])),
  hidden: v.optional(v.boolean()),
  path: v.optional(
    v.union([v.array(vConnectMapsApiClientContractsDtosPathLevel), v.null()])
  ),
  modifiedDate: v.optional(
    v.pipe(
      v.union([
        v.pipe(v.pipe(v.string(), v.isoTimestamp()), v.readonly()),
        v.null(),
      ]),
      v.readonly()
    )
  ),
  createdDate: v.optional(
    v.pipe(
      v.union([
        v.pipe(v.pipe(v.string(), v.isoTimestamp()), v.readonly()),
        v.null(),
      ]),
      v.readonly()
    )
  ),
});

export const vConnectMapsApiClientContractsDtosPrivateConnectFile =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    etag: v.optional(v.union([v.string(), v.null()])),
    name: v.optional(v.union([v.string(), v.null()])),
    projectId: v.optional(v.union([v.string(), v.null()])),
    parentEtagId: v.optional(v.union([v.string(), v.null()])),
    parentId: v.optional(v.union([v.string(), v.null()])),
    hasChildren: v.optional(v.boolean()),
    type: v.optional(v.union([v.string(), v.null()])),
    modified: v.optional(v.number()),
    createdOn: v.optional(v.number()),
    size: v.optional(v.union([v.string(), v.null()])),
    contentStorageObjectId: v.optional(v.union([v.string(), v.null()])),
    hidden: v.optional(v.boolean()),
    path: v.optional(
      v.union([v.array(vConnectMapsApiClientContractsDtosPathLevel), v.null()])
    ),
    modifiedDate: v.optional(
      v.pipe(
        v.union([
          v.pipe(v.pipe(v.string(), v.isoTimestamp()), v.readonly()),
          v.null(),
        ]),
        v.readonly()
      )
    ),
    createdDate: v.optional(
      v.pipe(
        v.union([
          v.pipe(v.pipe(v.string(), v.isoTimestamp()), v.readonly()),
          v.null(),
        ]),
        v.readonly()
      )
    ),
    versionId: v.optional(
      v.pipe(
        v.union([v.pipe(v.string(), v.readonly()), v.null()]),
        v.readonly()
      )
    ),
  });

export const vConnectMapsWebApiDtosBaseGeoLink = v.strictObject({
  hRef: v.optional(v.union([v.string(), v.null()])),
  rel: v.optional(v.union([v.string(), v.null()])),
  action: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosCacheMapBounds = v.strictObject({
  wgs84LatitudeNorth: v.optional(v.number()),
  wgs84LatitudeSouth: v.optional(v.number()),
  wgs84LongitudeEast: v.optional(v.number()),
  wgs84LongitudeWest: v.optional(v.number()),
  zoomLevel: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosEnumsBaseType = v.picklist([
  'SingleBase',
  'Vrs',
  'Auto',
]);

export const vConnectMapsWebApiDtosEnumsGeoAnnouncementStatus = v.picklist([
  'Dismissed',
  'RemindMeLater',
]);

export const vConnectMapsWebApiDtosEnumsGeoBackgroundMapType = v.picklist([
  'TrimbleStreet',
  'TrimbleSatellite',
  'OSM',
  'GoogleStreet',
  'GoogleSatellite',
  'ALK',
]);

export const vConnectMapsWebApiDtosEnumsGeoDataUpdateStatus = v.picklist([
  'NeedsUpdating',
  'Updated',
  'New',
]);

export const vConnectMapsWebApiDtosEnumsGeoDeleteStatusType = v.picklist([
  'AlreadyDeleted',
  'Deleted',
  'NotExists',
]);

export const vConnectMapsWebApiDtosEnumsGeoExportFormat = v.picklist([
  'CSV',
  'FILEGDB',
  'SHAPE',
  'OGCKML',
  'PDF',
  'DWG',
  'DXF',
  'FILEGDB_DIC',
]);

export const vConnectMapsWebApiDtosEnumsGeoExportJobStatus = v.picklist([
  'Unsubmitted',
  'Error',
  'InProgress',
  'Complete',
  'NoData',
]);

export const vConnectMapsWebApiDtosEnumsGeoFieldSystemsJobAssigneeType =
  v.picklist(['ConnectUser', 'ConnectGroup']);

export const vConnectMapsWebApiDtosEnumsGeoGisJobFormStatus = v.picklist([
  'NeedsUpdating',
  'Updated',
  'New',
]);

export const vConnectMapsWebApiDtosEnumsGeoGisJobStatus = v.picklist([
  'NEW',
  'IN_PROGRESS',
  'CLOSED',
]);

export const vConnectMapsWebApiDtosEnumsGeoJobPriority = v.picklist([
  'LOW',
  'NORMAL',
  'HIGH',
  'CRITICAL',
]);

export const vConnectMapsWebApiDtosEnumsGeoLayerType = v.picklist([
  'ImportedLayer',
  'TemplateLayer',
  'SurveyJobLayer',
  'SurveyFeatureLayer',
  'SurveyStakeoutLayer',
  'SurveySurfaceLayer',
]);

export const vConnectMapsWebApiDtosEnumsGeoLinearUnit = v.picklist([
  'Metre',
  'InternationalFoot',
  'USSurveyFoot',
  'GermanLegalMetre',
  'InternationalYard',
  'InternationalChain',
]);

export const vConnectMapsWebApiDtosEnumsGeoMapCacheJobStatus = v.picklist([
  'Error',
  'InProgress',
  'Complete',
  'NotSubmitted',
]);

export const vConnectMapsWebApiDtosEnumsGeoRequestDataUpdateJobStatus =
  v.picklist(['ActiveJobs', 'CompletedJobs']);

export const vConnectMapsWebApiDtosEnumsGeoSurveyJobStatus = v.picklist([
  'NEW',
  'IN_PROGRESS',
  'FIELD_WORK_COMPLETE',
  'QA_COMPLETE',
  'CLOSED',
  'RESOLVED',
]);

export const vConnectMapsWebApiDtosEnumsGeoSymbolType = v.picklist([
  'Geometric',
  'Feature',
  'Customizable',
]);

export const vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus = v.picklist([
  'Active',
  'Archived',
]);

export const vConnectMapsWebApiDtosEnumsGeoWorkspaceType = v.picklist([
  'GIS',
  'Survey',
  'FileViewer',
]);

export const vConnectMapsWebApiDtosEnumsInternetServerType = v.picklist([
  'Direct',
  'Ntrip',
  'Rtx',
]);

export const vConnectMapsWebApiDtosEnumsPeriodOfDay = v.picklist(['AM', 'PM']);

export const vConnectMapsWebApiDtosEnumsSerialPortParity = v.picklist([
  'Odd',
  'Even',
  'None',
]);

export const vConnectMapsWebApiDtosEnumsSourceType = v.picklist([
  'None',
  'Internet',
  'Serial',
  'Sbas',
  'TrimbleRTX',
  'SatelliteRTX',
]);

export const vConnectMapsWebApiDtosGeoBaseMapStyle = v.picklist([
  'StreetView',
  'SatelliteView',
]);

export const vConnectMapsWebApiDtosGeoDataUpdateForm = v.strictObject({
  formId: v.optional(v.pipe(v.string(), v.uuid())),
  templateSeriesId: v.optional(v.pipe(v.string(), v.uuid())),
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoDataUpdateStatus),
});

export const vConnectMapsWebApiDtosGeoDataUpdateJobAssignee = v.strictObject({
  type: v.optional(v.union([v.string(), v.null()])),
  id: v.optional(v.union([v.string(), v.null()])),
  name: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosGeoFeatureFlag = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  enabled: v.optional(v.boolean()),
  createdBy: v.optional(v.union([v.string(), v.null()])),
  updatedBy: v.optional(v.union([v.string(), v.null()])),
  createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  updatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

export const vConnectMapsWebApiDtosGeoFieldSystemsJobUser = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  email: v.optional(v.union([v.string(), v.null()])),
  connectUserId: v.optional(v.union([v.string(), v.null()])),
  tidUuid: v.optional(v.union([v.string(), v.null()])),
  tidTrn: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosGeoFieldSystemsJobAttachment =
  v.strictObject({
    fileName: v.optional(v.union([v.string(), v.null()])),
    downloadUrl: v.optional(v.union([v.string(), v.null()])),
    version: v.optional(v.union([v.string(), v.null()])),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
    size: v.optional(
      v.union([
        v.pipe(
          v.union([v.number(), v.string(), v.bigint()]),
          v.transform((x) => BigInt(x)),
          v.minValue(
            BigInt('-9223372036854775808'),
            'Invalid value: Expected int64 to be >= -2^63'
          ),
          v.maxValue(
            BigInt('9223372036854775807'),
            'Invalid value: Expected int64 to be <= 2^63-1'
          )
        ),
        v.null(),
      ])
    ),
    revision: v.optional(
      v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.null(),
      ])
    ),
    hash: v.optional(v.union([v.string(), v.null()])),
    createdBy: v.optional(vConnectMapsWebApiDtosGeoFieldSystemsJobUser),
    modifiedBy: v.optional(vConnectMapsWebApiDtosGeoFieldSystemsJobUser),
    modifiedDateTime: v.optional(
      v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
    ),
    createdDateTime: v.optional(
      v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
    ),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosGeoGisJobAssignee = v.strictObject({
  type: v.optional(vConnectMapsWebApiDtosEnumsGeoFieldSystemsJobAssigneeType),
  id: v.optional(v.union([v.string(), v.null()])),
  name: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosGeoGisJobForm = v.strictObject({
  formId: v.optional(v.pipe(v.string(), v.uuid())),
  templateSeriesId: v.optional(v.pipe(v.string(), v.uuid())),
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoGisJobFormStatus),
});

export const vConnectMapsWebApiDtosGeoMapCacheBody = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  wgs84LatitudeNorth: v.optional(v.number()),
  wgs84LatitudeSouth: v.optional(v.number()),
  wgs84LongitudeEast: v.optional(v.number()),
  wgs84LongitudeWest: v.optional(v.number()),
  zoomLevel: v.optional(v.union([v.string(), v.null()])),
  baseMapStyle: v.optional(vConnectMapsWebApiDtosGeoBaseMapStyle),
  zoomLevelStart: v.optional(
    v.pipe(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.readonly()
    )
  ),
  zoomLevelEnd: v.optional(
    v.pipe(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.readonly()
    )
  ),
});

export const vConnectMapsWebApiDtosGeoResizeMethodType = v.picklist([
  'CropToBestFit',
  'Stretch',
  'DownOnlyToIdeal',
  'AlwaysToIdeal',
]);

export const vConnectMapsWebApiDtosProcessStatus = v.picklist([
  'Pending',
  'InProgress',
  'Stopped',
  'Canceled',
  'Failed',
  'Completed',
  'CompletedInvalid',
]);

export const vConnectMapsWebApiDtosGeoBackgroundJob = v.strictObject({
  id: v.optional(v.pipe(v.string(), v.uuid())),
  status: v.optional(vConnectMapsWebApiDtosProcessStatus),
});

export const vConnectMapsWebApiDtosRealtimeCorrectionBody = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  description: v.optional(v.union([v.string(), v.null()])),
  sourceType1: v.optional(vConnectMapsWebApiDtosEnumsSourceType),
  sourceType2IsSbas: v.optional(v.boolean()),
  baseType: v.optional(vConnectMapsWebApiDtosEnumsBaseType),
  datumSystemId: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  datumComponentId: v.optional(v.union([v.string(), v.null()])),
  internetServerType: v.optional(vConnectMapsWebApiDtosEnumsInternetServerType),
  internetUrl: v.optional(v.union([v.string(), v.null()])),
  internetPort: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  internetUsername: v.optional(v.union([v.string(), v.null()])),
  internetPassword: v.optional(v.union([v.string(), v.null()])),
  ntripSettingsString: v.optional(v.union([v.string(), v.null()])),
  serialPortComPort: v.optional(v.union([v.string(), v.null()])),
  serialPortBaudRate: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  serialPortDataBits: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  serialPortStopBits: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  serialPortParity: v.optional(vConnectMapsWebApiDtosEnumsSerialPortParity),
});

export const vConnectMapsWebApiDtosRequestsDuplicateTemplateMethod = v.picklist(
  ['DuplicateTemplates', 'LinkTemplates']
);

export const vConnectMapsWebApiDtosRequestsGisJobGeoPatchGisJobAssignee =
  v.strictObject({
    add: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosGeoGisJobAssignee), v.null()])
    ),
    removalIds: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGisJobGeoPatchGisJobForm =
  v.strictObject({
    upsert: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosGeoGisJobForm), v.null()])
    ),
    removalIds: v.optional(
      v.union([v.array(v.pipe(v.string(), v.uuid())), v.null()])
    ),
  });

export const vConnectMapsWebApiDtosRequestsGisJobGeoPatchGisJobRequest =
  v.strictObject({
    name: v.optional(v.union([v.string(), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoGisJobStatus),
    assignees: v.optional(
      vConnectMapsWebApiDtosRequestsGisJobGeoPatchGisJobAssignee
    ),
    forms: v.optional(vConnectMapsWebApiDtosRequestsGisJobGeoPatchGisJobForm),
    workspaceId: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGisJobGeoPostGisJobRequest =
  v.strictObject({
    name: v.optional(v.union([v.string(), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    forms: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosGeoGisJobForm), v.null()])
    ),
    assignees: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosGeoGisJobAssignee), v.null()])
    ),
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    migratedTodoId: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoAnnouncementsTrackingRequest =
  v.strictObject({
    announcementId: v.optional(v.pipe(v.string(), v.uuid())),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoAnnouncementStatus),
  });

export const vConnectMapsWebApiDtosRequestsGeoBatchDeleteRequest =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoBatchGetRequest = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosRequestsGeoCreateLayerRelationshipsRequest =
  v.strictObject({
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    layerId: v.optional(v.union([v.string(), v.null()])),
    isLocked: v.optional(v.boolean()),
  });

export const vConnectMapsWebApiDtosRequestsGeoGetTemplateDeltasRequest =
  v.strictObject({
    seriesId: v.optional(v.pipe(v.string(), v.uuid())),
    lowerVersion: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoBatchParametersRequest1ConnectMapsWebApiDtosRequestsGeoGetTemplateDeltasRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    parameters: v.optional(
      vConnectMapsWebApiDtosRequestsGeoGetTemplateDeltasRequest
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPatchDataUpdateJobRequest =
  v.strictObject({
    forms: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosGeoDataUpdateForm), v.null()])
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPatchLayerRelationshipsRequest =
  v.strictObject({
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    layerId: v.optional(v.union([v.string(), v.null()])),
    isLocked: v.optional(v.boolean()),
  });

export const vConnectMapsWebApiDtosRequestsGeoPatchMapCacheRequest =
  v.strictObject({
    name: v.optional(v.union([v.string(), v.null()])),
    bounds: v.optional(vConnectMapsWebApiDtosCacheMapBounds),
  });

export const vConnectMapsWebApiDtosRequestsGeoPatchWorkspaceRelationshipsRequest =
  v.strictObject({
    realtimeCorrectionIds: v.optional(v.union([v.array(v.string()), v.null()])),
    layerIds: v.optional(v.union([v.array(v.string()), v.null()])),
    dataUpdateJobIds: v.optional(v.union([v.array(v.string()), v.null()])),
    mapCacheIds: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostDataUpdateJobRequest =
  v.strictObject({
    todoId: v.optional(v.union([v.string(), v.null()])),
    forms: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosGeoDataUpdateForm), v.null()])
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostFeaturesImportJobRequest =
  v.strictObject({
    importId: v.optional(v.pipe(v.string(), v.uuid())),
    importFileName: v.optional(v.union([v.string(), v.null()])),
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    sourceLayerNames: v.optional(v.union([v.array(v.string()), v.null()])),
    layerStyles: v.optional(v.union([v.array(v.string()), v.null()])),
    isComplete: v.optional(v.boolean()),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostImageRequest = v.strictObject(
  {
    uuid: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  }
);

export const vConnectMapsWebApiDtosRequestsGeoPostLayerRequest = v.strictObject(
  {
    layerName: v.optional(v.union([v.string(), v.null()])),
    templateId: v.optional(v.union([v.string(), v.null()])),
    styleId: v.optional(v.union([v.string(), v.null()])),
    layerType: v.optional(vConnectMapsWebApiDtosEnumsGeoLayerType),
    fileVersionId: v.optional(v.union([v.string(), v.null()])),
  }
);

export const vConnectMapsWebApiDtosRequestsGeoPostMapCacheRequest =
  v.strictObject({
    geoMapCacheBody: v.optional(vConnectMapsWebApiDtosGeoMapCacheBody),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostRealtimeCorrectionRequest =
  v.strictObject({
    realtimeCorrection: v.optional(
      vConnectMapsWebApiDtosRealtimeCorrectionBody
    ),
    isGlobal: v.optional(v.boolean()),
    workspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
    excludedWorkspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostStyleRequest = v.strictObject(
  {
    name: v.pipe(v.string(), v.minLength(1)),
    image: v.optional(v.union([v.string(), v.null()])),
    lineColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    lineStyle: v.optional(
      v.union([
        v.pipe(v.string(), v.regex(/^(SOLID)|(DASHED)|(DOTTED)$/)),
        v.null(),
      ])
    ),
    lineWeight: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1'),
        v.minValue(1),
        v.maxValue(10)
      )
    ),
    fillColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    fillOpacity: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1'),
        v.minValue(0),
        v.maxValue(100)
      )
    ),
    symbolId: v.optional(v.union([v.string(), v.null()])),
  }
);

export const vConnectMapsWebApiDtosRequestsGeoPostSymbolRequest =
  v.strictObject({
    symbolDefinitionUuid: v.pipe(v.string(), v.uuid()),
    fillColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    outlineColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    text: v.optional(v.union([v.pipe(v.string(), v.maxLength(2)), v.null()])),
    color: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostTemplatePublicationRequest =
  v.strictObject({
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    templateSeriesId: v.optional(v.pipe(v.string(), v.uuid())),
    templateVersion: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostTemplateRelationshipRequest =
  v.strictObject({
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    seriesId: v.optional(v.pipe(v.string(), v.uuid())),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostUserSettingsRequest =
  v.strictObject({
    type: v.optional(v.union([v.pipe(v.string(), v.maxLength(45)), v.null()])),
    name: v.optional(v.union([v.pipe(v.string(), v.maxLength(45)), v.null()])),
    value: v.optional(v.unknown()),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutDataUpdateJobRequest =
  v.strictObject({
    forms: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosGeoDataUpdateForm), v.null()])
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutLayerRequest = v.strictObject({
  layerName: v.optional(v.union([v.string(), v.null()])),
  templateId: v.optional(v.union([v.string(), v.null()])),
  styleId: v.optional(v.union([v.string(), v.null()])),
  layerType: v.optional(vConnectMapsWebApiDtosEnumsGeoLayerType),
});

export const vConnectMapsWebApiDtosRequestsGeoPutRealtimeCorrectionRequest =
  v.strictObject({
    realtimeCorrection: v.optional(
      vConnectMapsWebApiDtosRealtimeCorrectionBody
    ),
    isGlobal: v.optional(v.boolean()),
    workspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
    excludedWorkspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutStyleRequest = v.strictObject({
  name: v.pipe(v.string(), v.minLength(1)),
  image: v.optional(v.union([v.string(), v.null()])),
  lineColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  lineStyle: v.optional(
    v.union([
      v.pipe(v.string(), v.regex(/^(SOLID)|(DASHED)|(DOTTED)$/)),
      v.null(),
    ])
  ),
  lineWeight: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1'),
      v.minValue(1),
      v.maxValue(10)
    )
  ),
  fillColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  fillOpacity: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1'),
      v.minValue(0),
      v.maxValue(100)
    )
  ),
  symbolId: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosRequestsGeoPutSymbolRequest = v.strictObject(
  {
    symbolDefinitionUuid: v.pipe(v.string(), v.uuid()),
    fillColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    outlineColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    text: v.optional(v.union([v.pipe(v.string(), v.maxLength(2)), v.null()])),
    color: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
  }
);

export const vConnectMapsWebApiDtosRequestsGeoPutUserSettingsRequest =
  v.strictObject({
    value: v.optional(v.unknown()),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutWorkspaceRelationshipsRequest =
  v.strictObject({
    realtimeCorrectionIds: v.optional(v.union([v.array(v.string()), v.null()])),
    layerIds: v.optional(v.union([v.array(v.string()), v.null()])),
    dataUpdateJobIds: v.optional(v.union([v.array(v.string()), v.null()])),
    mapCacheIds: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoStyleOverrideModel =
  v.strictObject({
    lineColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    fillColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoSymbolOverrideModel =
  v.strictObject({
    fillColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    outlineColor: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    color: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostStyleOverrideRequest =
  v.strictObject({
    filter: v.pipe(v.string(), v.minLength(1)),
    styleOverride: v.optional(
      vConnectMapsWebApiDtosRequestsGeoStyleOverrideModel
    ),
    symbolOverride: v.optional(
      vConnectMapsWebApiDtosRequestsGeoSymbolOverrideModel
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutStyleOverrideRequest =
  v.strictObject({
    filter: v.pipe(v.string(), v.minLength(1)),
    styleOverride: v.optional(
      vConnectMapsWebApiDtosRequestsGeoStyleOverrideModel
    ),
    symbolOverride: v.optional(
      vConnectMapsWebApiDtosRequestsGeoSymbolOverrideModel
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoWorkspaceRelationshipsInfo =
  v.strictObject({
    realtimeCorrectionIds: v.optional(v.union([v.array(v.string()), v.null()])),
    layerIds: v.optional(v.union([v.array(v.string()), v.null()])),
    dataUpdateJobIds: v.optional(v.union([v.array(v.string()), v.null()])),
    mapCacheIds: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsSurveyJobGeoPatchSurveyJobAssignee =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsSurveyJobGeoPatchSurveyJobRequest =
  v.strictObject({
    assignee: v.optional(
      vConnectMapsWebApiDtosRequestsSurveyJobGeoPatchSurveyJobAssignee
    ),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoSurveyJobStatus),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
    linkedFiles: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsSurveyJobGeoPostSurveyJobRequest =
  v.strictObject({
    name: v.optional(v.union([v.string(), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    assigneeUserId: v.optional(v.union([v.string(), v.null()])),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
    linkedFiles: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGisJobGeoGisReturnedJob =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    userId: v.optional(v.union([v.string(), v.null()])),
    returnedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  });

export const vConnectMapsWebApiDtosResponsesGisJobGeoGisJob = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  description: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoGisJobStatus),
  percentageComplete: v.optional(v.number()),
  forms: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosGeoGisJobForm), v.null()])
  ),
  isCompleted: v.optional(v.union([v.boolean(), v.null()])),
  workspaceId: v.optional(v.union([v.string(), v.null()])),
  assignees: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosGeoGisJobAssignee), v.null()])
  ),
  returnedJobs: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGisJobGeoGisReturnedJob),
      v.null(),
    ])
  ),
  priority: v.optional(vConnectMapsWebApiDtosEnumsGeoJobPriority),
  dueDate: v.optional(
    v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
  ),
  createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  updatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  migratedTodoId: v.optional(v.union([v.string(), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoAnnouncementsTracking =
  v.strictObject({
    userId: v.optional(v.union([v.string(), v.null()])),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoAnnouncementStatus),
    createdDateTime: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    updatedDateTime: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  });

export const vConnectMapsWebApiDtosResponsesGeoAnnouncement = v.strictObject({
  announcement: v.optional(v.unknown()),
  tracking: v.optional(vConnectMapsWebApiDtosResponsesGeoAnnouncementsTracking),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoAnnouncements = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoAnnouncement), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoDataUpdateJobStatus = v.picklist(
  ['NEW', 'IN_PROGRESS', 'RESOLVED', 'CLOSED', 'BLOCKED']
);

export const vConnectMapsWebApiDtosResponsesGeoDeleteStatus = v.strictObject({
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoDeleteStatusType),
});

export const vConnectMapsWebApiDtosResponsesGeoError = v.strictObject({
  failure: v.optional(v.unknown()),
  code: v.optional(v.union([v.string(), v.null()])),
  message: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoDeleteStatus_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosResponsesGeoDeleteStatus),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1SystemObject_SystemPrivateCoreLib_Version_8000_Culture_neutral_PublicKeyToken_7Cec85D7Bea7798E =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(v.unknown()),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoDeleteStatus_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(
          vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoDeleteStatus_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
        ),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponses1SystemObject_SystemPrivateCoreLib_Version_8000_Culture_neutral_PublicKeyToken_7Cec85D7Bea7798E =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(
          vConnectMapsWebApiDtosResponsesGeoBatchResponse1SystemObject_SystemPrivateCoreLib_Version_8000_Culture_neutral_PublicKeyToken_7Cec85D7Bea7798E
        ),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoExportJob = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  emailAddress: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoExportJobStatus),
  packageLinks: v.optional(v.union([v.array(v.string()), v.null()])),
  exportFormat: v.optional(vConnectMapsWebApiDtosEnumsGeoExportFormat),
  exportSRS: v.optional(v.union([v.string(), v.null()])),
  downloadExpireDate: v.optional(
    v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
  ),
  workspaceId: v.optional(v.union([v.string(), v.null()])),
  fileSizeinBytes: v.optional(
    v.union([
      v.pipe(
        v.union([v.number(), v.string(), v.bigint()]),
        v.transform((x) => BigInt(x)),
        v.minValue(
          BigInt('-9223372036854775808'),
          'Invalid value: Expected int64 to be >= -2^63'
        ),
        v.maxValue(
          BigInt('9223372036854775807'),
          'Invalid value: Expected int64 to be <= 2^63-1'
        )
      ),
      v.null(),
    ])
  ),
  featuresCount: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  createdBy: v.optional(v.union([v.string(), v.null()])),
  createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoExportJobs = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoExportJob), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoFeatureImportJobStatus =
  v.picklist(['Submitted', 'InProgress', 'Completed', 'Failed']);

export const vConnectMapsWebApiDtosResponsesGeoFeautreImportJob =
  v.strictObject({
    importId: v.optional(v.pipe(v.string(), v.uuid())),
    importFileName: v.optional(v.union([v.string(), v.null()])),
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    status: v.optional(
      vConnectMapsWebApiDtosResponsesGeoFeatureImportJobStatus
    ),
    startedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    importedLayerIds: v.optional(v.union([v.array(v.string()), v.null()])),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoFeautreImportJobs =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoFeautreImportJob),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoFieldApplication =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    fieldId: v.optional(v.union([v.string(), v.null()])),
    category: v.optional(v.union([v.string(), v.null()])),
    subcategory: v.optional(v.union([v.string(), v.null()])),
    layoutSchema: v.optional(v.union([v.string(), v.null()])),
    validationRule: v.optional(v.union([v.string(), v.null()])),
    fieldTransformationRule: v.optional(v.union([v.string(), v.null()])),
    fieldCategories: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoField = v.strictObject({
  fieldType: v.optional(v.union([v.string(), v.null()])),
  uuid: v.optional(v.pipe(v.string(), v.uuid())),
  applications: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoFieldApplication),
      v.null(),
    ])
  ),
  schema: v.optional(v.union([v.string(), v.null()])),
  isDefault: v.optional(v.boolean()),
  createdBy: v.optional(v.union([v.string(), v.null()])),
  modifiedBy: v.optional(v.union([v.string(), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoFields = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoField), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoImageObject = v.strictObject({
  uuid: v.optional(v.pipe(v.string(), v.uuid())),
  uploadUrl: v.optional(v.union([v.string(), v.null()])),
  thumbnailUploadUrl: v.optional(v.union([v.string(), v.null()])),
  downloadUrl: v.optional(v.union([v.string(), v.null()])),
  thumbnailDownloadUrl: v.optional(v.union([v.string(), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoLayerAutoincrementResult =
  v.strictObject({
    layerId: v.optional(v.union([v.string(), v.null()])),
    propertyNameToValueMap: v.optional(v.union([v.object({}), v.null()])),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoLayerAutoincrementResult_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(
      vConnectMapsWebApiDtosResponsesGeoLayerAutoincrementResult
    ),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoLayerAutoincrementResult_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(
          vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoLayerAutoincrementResult_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
        ),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoLayerStyleOverride =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    styleId: v.optional(v.union([v.string(), v.null()])),
    filter: v.optional(v.union([v.string(), v.null()])),
    styleOverride: v.optional(
      vConnectMapsWebApiDtosRequestsGeoStyleOverrideModel
    ),
    symbolOverride: v.optional(
      vConnectMapsWebApiDtosRequestsGeoSymbolOverrideModel
    ),
  });

export const vConnectMapsWebApiDtosResponsesGeoLayerTemplatePublication =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    templateSeriesId: v.optional(v.pipe(v.string(), v.uuid())),
  });

export const vConnectMapsWebApiDtosResponsesGeoLayerWorkspace = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  name: v.optional(v.union([v.string(), v.null()])),
  description: v.optional(v.union([v.string(), v.null()])),
  connectFileId: v.optional(v.union([v.string(), v.null()])),
  uuid: v.optional(v.pipe(v.string(), v.uuid())),
  hasThumbnail: v.optional(v.boolean()),
  backgroundMapType: v.optional(
    vConnectMapsWebApiDtosEnumsGeoBackgroundMapType
  ),
  isDeleted: v.optional(v.boolean()),
  crs: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus),
});

export const vConnectMapsWebApiDtosResponsesGeoMapCache = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  fileSize: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  fileName: v.optional(v.union([v.string(), v.null()])),
  jobToken: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoMapCacheJobStatus),
  mD5: v.optional(v.union([v.string(), v.null()])),
  compressed: v.optional(v.boolean()),
  featureJSON: v.optional(v.union([v.string(), v.null()])),
  baseMapStyle: v.optional(vConnectMapsWebApiDtosGeoBaseMapStyle),
  createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  updatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  workspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoMapCaches = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoMapCache), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoProject = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  createdOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  modifiedOn: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  rootId: v.optional(v.union([v.string(), v.null()])),
  description: v.optional(v.union([v.string(), v.null()])),
  location: v.optional(v.union([v.string(), v.null()])),
  origin: v.optional(v.union([v.string(), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoProjects = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoProject), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoRealtimeCorrection =
  v.strictObject({
    name: v.optional(v.union([v.string(), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    updatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    sourceType1: v.optional(vConnectMapsWebApiDtosEnumsSourceType),
    sourceType2IsSbas: v.optional(v.boolean()),
    baseType: v.optional(vConnectMapsWebApiDtosEnumsBaseType),
    datumSystemId: v.optional(
      v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.null(),
      ])
    ),
    datumComponentId: v.optional(v.union([v.string(), v.null()])),
    internetServerType: v.optional(
      vConnectMapsWebApiDtosEnumsInternetServerType
    ),
    internetUrl: v.optional(v.union([v.string(), v.null()])),
    internetPort: v.optional(
      v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.null(),
      ])
    ),
    internetUsername: v.optional(v.union([v.string(), v.null()])),
    internetPassword: v.optional(v.union([v.string(), v.null()])),
    ntripSettingsString: v.optional(v.union([v.string(), v.null()])),
    serialPortComPort: v.optional(v.union([v.string(), v.null()])),
    serialPortBaudRate: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    serialPortDataBits: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    serialPortStopBits: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    serialPortParity: v.optional(vConnectMapsWebApiDtosEnumsSerialPortParity),
    isGlobal: v.optional(v.boolean()),
    workspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
    excludedWorkspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoRealtimeCorrectionNtripSetting =
  v.strictObject({
    ntripServerSettings: v.optional(v.union([v.string(), v.null()])),
    server: v.optional(v.union([v.string(), v.null()])),
    ntripId: v.optional(v.union([v.string(), v.null()])),
    country: v.optional(v.union([v.string(), v.null()])),
    carrier: v.optional(v.union([v.string(), v.null()])),
    system: v.optional(v.union([v.string(), v.null()])),
    format: v.optional(v.union([v.string(), v.null()])),
    details: v.optional(v.union([v.string(), v.null()])),
    network: v.optional(v.union([v.string(), v.null()])),
    generator: v.optional(v.union([v.string(), v.null()])),
    solution: v.optional(v.union([v.string(), v.null()])),
    fee: v.optional(v.union([v.string(), v.null()])),
    bitRate: v.optional(v.union([v.string(), v.null()])),
    misc: v.optional(v.union([v.string(), v.null()])),
    nmea: v.optional(v.union([v.string(), v.null()])),
    authentication: v.optional(v.union([v.string(), v.null()])),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoRealtimeCorrectionNtripSettings =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(
          vConnectMapsWebApiDtosResponsesGeoRealtimeCorrectionNtripSetting
        ),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoRealtimeCorrections =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoRealtimeCorrection),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoReturnedDataUpdateJob =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    userId: v.optional(v.union([v.string(), v.null()])),
    returnedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  });

export const vConnectMapsWebApiDtosResponsesGeoDataUpdateJob = v.strictObject({
  uuid: v.optional(v.pipe(v.string(), v.uuid())),
  todoId: v.optional(v.union([v.string(), v.null()])),
  title: v.optional(v.union([v.string(), v.null()])),
  description: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(vConnectMapsWebApiDtosResponsesGeoDataUpdateJobStatus),
  priority: v.optional(v.union([v.string(), v.null()])),
  dueDate: v.optional(
    v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
  ),
  percentageComplete: v.optional(v.number()),
  forms: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosGeoDataUpdateForm), v.null()])
  ),
  isCompleted: v.optional(v.union([v.boolean(), v.null()])),
  workspaceIds: v.optional(v.union([v.array(v.string()), v.null()])),
  todo: v.optional(v.unknown()),
  assignees: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosGeoDataUpdateJobAssignee), v.null()])
  ),
  returnedJobs: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoReturnedDataUpdateJob),
      v.null(),
    ])
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoDataUpdateJobs = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoDataUpdateJob),
      v.null(),
    ])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoReturnedJob = v.strictObject({
  projectId: v.optional(v.union([v.string(), v.null()])),
  userId: v.optional(v.union([v.string(), v.null()])),
  dataUpdateJobId: v.optional(v.union([v.string(), v.null()])),
  returnedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoReturnedJobs = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoReturnedJob), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoStyleOverride = v.strictObject({
  styleId: v.optional(v.union([v.string(), v.null()])),
  filter: v.optional(v.union([v.string(), v.null()])),
  styleOverride: v.optional(
    vConnectMapsWebApiDtosRequestsGeoStyleOverrideModel
  ),
  symbolOverride: v.optional(
    vConnectMapsWebApiDtosRequestsGeoSymbolOverrideModel
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoStyleOverrides = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoStyleOverride),
      v.null(),
    ])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoTemplatePublication =
  v.strictObject({
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    templateSeriesId: v.optional(v.pipe(v.string(), v.uuid())),
    templateVersion: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    template: v.optional(v.unknown()),
    templateId: v.optional(v.union([v.string(), v.null()])),
    publicationId: v.optional(v.pipe(v.string(), v.uuid())),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoTemplatePublications =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoTemplatePublication),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoTemplateRelationship =
  v.strictObject({
    workspaceId: v.optional(v.union([v.string(), v.null()])),
    seriesId: v.optional(v.pipe(v.string(), v.uuid())),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoTemplateRelationships =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoTemplateRelationship),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoTemplateWorkspace =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    name: v.optional(v.union([v.string(), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus),
  });

export const vConnectMapsWebApiDtosResponsesGeoUser = v.strictObject({
  userName: v.optional(v.union([v.string(), v.null()])),
  email: v.optional(v.union([v.string(), v.null()])),
  tiduuid: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  firstName: v.optional(v.union([v.string(), v.null()])),
  lastName: v.optional(v.union([v.string(), v.null()])),
  locale: v.optional(v.union([v.string(), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoUserActivation = v.strictObject({
  orgId: v.optional(v.union([v.string(), v.null()])),
  masterOrgId: v.optional(v.union([v.string(), v.null()])),
  orgName: v.optional(v.union([v.string(), v.null()])),
  sku: v.optional(v.union([v.string(), v.null()])),
  activationDate: v.optional(v.union([v.string(), v.null()])),
  expiryDate: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoUserGroup = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  projectId: v.optional(v.union([v.string(), v.null()])),
  usersCount: v.optional(
    v.pipe(
      v.union([v.number(), v.string(), v.bigint()]),
      v.transform((x) => BigInt(x)),
      v.minValue(
        BigInt('-9223372036854775808'),
        'Invalid value: Expected int64 to be >= -2^63'
      ),
      v.maxValue(
        BigInt('9223372036854775807'),
        'Invalid value: Expected int64 to be <= 2^63-1'
      )
    )
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoGroups = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoUserGroup), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoUserProfile = v.strictObject({
  firstName: v.optional(v.union([v.string(), v.null()])),
  lastName: v.optional(v.union([v.string(), v.null()])),
  email: v.optional(v.union([v.string(), v.null()])),
  status: v.optional(v.union([v.string(), v.null()])),
  thumbnail: v.optional(v.union([v.string(), v.null()])),
  role: v.optional(v.union([v.string(), v.null()])),
  lastAccessed: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  language: v.optional(v.union([v.string(), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoUserProfiles = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoUserProfile), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoUserSettings = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  type: v.optional(v.union([v.string(), v.null()])),
  settingsName: v.optional(v.union([v.string(), v.null()])),
  value: v.optional(v.unknown()),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoUserSettingses = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoUserSettings), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds = v.strictObject(
  {
    latitudeNorth: v.optional(v.number()),
    latitudeSouth: v.optional(v.number()),
    longitudeEast: v.optional(v.number()),
    longitudeWest: v.optional(v.number()),
  }
);

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystem =
  v.strictObject({
    zoneGroupComponentId: v.optional(v.union([v.string(), v.null()])),
    zoneComponentId: v.optional(v.union([v.string(), v.null()])),
    datumComponentId: v.optional(v.union([v.string(), v.null()])),
    geoidComponentId: v.optional(v.union([v.string(), v.null()])),
    localReferenceFrameComponentId: v.optional(v.union([v.string(), v.null()])),
    horizontalUnit: v.optional(vConnectMapsWebApiDtosEnumsGeoLinearUnit),
    verticalUnit: v.optional(vConnectMapsWebApiDtosEnumsGeoLinearUnit),
    cscmResourceId: v.optional(
      v.pipe(
        v.union([v.pipe(v.string(), v.readonly()), v.null()]),
        v.readonly()
      )
    ),
    cscmLocalLLHResourceId: v.optional(
      v.pipe(
        v.union([v.pipe(v.string(), v.readonly()), v.null()]),
        v.readonly()
      )
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostDuplicateWorkspaceRequest =
  v.strictObject({
    sourceWorkspaceId: v.optional(v.union([v.string(), v.null()])),
    name: v.optional(v.union([v.pipe(v.string(), v.maxLength(44)), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    use_Source_CoordinationSystem: v.optional(v.boolean()),
    duplicationMethod: v.optional(
      vConnectMapsWebApiDtosRequestsDuplicateTemplateMethod
    ),
    coordinateSystem: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystem
    ),
    bounds: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds),
    enablePostProcessing: v.optional(v.boolean()),
    connectFolderId: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceModel = v.strictObject({
  isCustomThumbnailImage: v.optional(v.boolean()),
});

export const vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingAvailabilityTime =
  v.strictObject({
    timeOfDay: v.optional(v.union([v.string(), v.null()])),
    periodOfDay: v.optional(vConnectMapsWebApiDtosEnumsPeriodOfDay),
    timeZoneOffset: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingBody =
  v.strictObject({
    enabled: v.optional(v.boolean()),
    locked: v.optional(v.boolean()),
    useUserBaseFilesFolder: v.optional(v.boolean()),
    userBaseFilesFolderId: v.optional(v.union([v.string(), v.null()])),
    userBaseFilesAvailabilityTime: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingAvailabilityTime
    ),
  });

export const vConnectMapsWebApiDtosRequestsGeoPatchWorkspaceRequest =
  v.strictObject({
    name: v.optional(v.union([v.pipe(v.string(), v.maxLength(44)), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    backgroundMapType: v.optional(
      vConnectMapsWebApiDtosEnumsGeoBackgroundMapType
    ),
    relationships: v.optional(
      vConnectMapsWebApiDtosRequestsGeoWorkspaceRelationshipsInfo
    ),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus),
    postProcessingBody: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingBody
    ),
    bounds: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostWorkspaceRequest =
  v.strictObject({
    name: v.optional(v.union([v.pipe(v.string(), v.maxLength(44)), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    connectFileId: v.optional(v.union([v.string(), v.null()])),
    connectFolderId: v.optional(v.union([v.string(), v.null()])),
    backgroundMapType: v.optional(
      vConnectMapsWebApiDtosEnumsGeoBackgroundMapType
    ),
    coordinateSystem: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystem
    ),
    bounds: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds),
    postProcessingBody: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingBody
    ),
    tectonicPlate: v.optional(v.union([v.string(), v.null()])),
    workspaceModel: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceModel
    ),
    type: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceType),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutWorkspaceRequest =
  v.strictObject({
    name: v.optional(v.union([v.pipe(v.string(), v.maxLength(44)), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    backgroundMapType: v.optional(
      vConnectMapsWebApiDtosEnumsGeoBackgroundMapType
    ),
    relationships: v.optional(
      vConnectMapsWebApiDtosRequestsGeoWorkspaceRelationshipsInfo
    ),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus),
    postProcessingBody: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingBody
    ),
  });

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceRelationships =
  v.strictObject({
    realtimeCorrectionIds: v.optional(v.union([v.array(v.string()), v.null()])),
    layerIds: v.optional(v.union([v.array(v.string()), v.null()])),
    dataUpdateJobIds: v.optional(v.union([v.array(v.string()), v.null()])),
    mapCacheIds: v.optional(v.union([v.array(v.string()), v.null()])),
    userIds: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobAssignee =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    type: v.optional(v.union([v.string(), v.null()])),
    connectUserId: v.optional(v.union([v.string(), v.null()])),
    name: v.optional(v.union([v.string(), v.null()])),
    email: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJob =
  v.strictObject({
    name: v.optional(v.union([v.string(), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    jobFolderLocation: v.optional(v.union([v.string(), v.null()])),
    assignees: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobAssignee),
        v.null(),
      ])
    ),
    priority: v.optional(vConnectMapsWebApiDtosEnumsGeoJobPriority),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoSurveyJobStatus),
    lifeState: v.optional(v.union([v.string(), v.null()])),
    attachments: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosGeoFieldSystemsJobAttachment),
        v.null(),
      ])
    ),
    linkedFiles: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosGeoFieldSystemsJobAttachment),
        v.null(),
      ])
    ),
    rootDataFile: v.optional(
      vConnectMapsWebApiDtosGeoFieldSystemsJobAttachment
    ),
    rootDataFileJxl: v.optional(
      vConnectMapsWebApiDtosGeoFieldSystemsJobAttachment
    ),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
    createdBy: v.optional(vConnectMapsWebApiDtosGeoFieldSystemsJobUser),
    modifiedBy: v.optional(vConnectMapsWebApiDtosGeoFieldSystemsJobUser),
    createdDateTime: v.optional(
      v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
    ),
    modifiedDateTime: v.optional(
      v.union([v.pipe(v.string(), v.isoTimestamp()), v.null()])
    ),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobAttachments =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosGeoFieldSystemsJobAttachment),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobs =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJob),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosTemplateDistanceUnit = v.picklist([
  'Meters',
  'Feet',
  'Inches',
  'Yards',
  'Kilometers',
  'Miles',
  'NauticalMiles',
  'USSurveyFeet',
  'Millimeters',
  'NamibianMeters',
  'Chains',
  'Links',
  'Centimeters',
  'Acres',
  'SquareMeters',
  'SquareKilometers',
  'SquareFeet',
  'Hectares',
]);

export const vConnectMapsWebApiDtosTemplateFieldType = v.picklist([
  'Text',
  'Number',
  'YesNo',
  'Date',
  'Choice',
  'Image',
  'Signature',
  'PageHeader',
  'Autofield',
  'CustomField',
  'Barcode',
  'CodedChoice',
  'SensorGroup',
]);

export const vConnectMapsWebApiDtosTemplateFieldModelBase = v.strictObject({
  uuid: v.optional(v.pipe(v.string(), v.uuid())),
  displayName: v.optional(v.union([v.string(), v.null()])),
  name: v.optional(v.union([v.string(), v.null()])),
  type: v.optional(vConnectMapsWebApiDtosTemplateFieldType),
  ordinal: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  groupId: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  sensorMappingId: v.optional(v.union([v.string(), v.null()])),
  required: v.optional(v.union([v.boolean(), v.null()])),
  readOnly: v.optional(v.union([v.boolean(), v.null()])),
  requiredForUpdate: v.optional(v.union([v.boolean(), v.null()])),
  readOnlyForUpdate: v.optional(v.union([v.boolean(), v.null()])),
  repeatField: v.optional(v.union([v.boolean(), v.null()])),
  incrementRepeatValue: v.optional(v.union([v.number(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoTemplateDeltas = v.strictObject({
  additions: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosTemplateFieldModelBase), v.null()])
  ),
  removals: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosTemplateFieldModelBase), v.null()])
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosTemplateGeoGeometryType = v.picklist([
  'Point',
  'Line',
  'Area',
  'None',
]);

export const vConnectMapsWebApiDtosResponsesGeoLayerSymbol = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  symbolDefinitionId: v.optional(v.union([v.string(), v.null()])),
  type: v.optional(vConnectMapsWebApiDtosEnumsGeoSymbolType),
  geometryType: v.optional(vConnectMapsWebApiDtosTemplateGeoGeometryType),
  symbolDefinitionUuid: v.optional(v.pipe(v.string(), v.uuid())),
  symbolName: v.optional(v.union([v.string(), v.null()])),
  svgImage: v.optional(v.union([v.string(), v.null()])),
  fillColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  outlineColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  text: v.optional(v.union([v.string(), v.null()])),
  color: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
});

export const vConnectMapsWebApiDtosResponsesGeoLayerTemplate = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  seriesId: v.optional(v.pipe(v.string(), v.uuid())),
  version: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  templateName: v.optional(v.union([v.string(), v.null()])),
  geometryType: v.optional(vConnectMapsWebApiDtosTemplateGeoGeometryType),
  geometryColorHexRGB: v.optional(v.union([v.string(), v.null()])),
  isPublished: v.optional(v.boolean()),
});

export const vConnectMapsWebApiDtosResponsesGeoLayer = v.strictObject({
  layerName: v.optional(v.union([v.string(), v.null()])),
  template: v.optional(vConnectMapsWebApiDtosResponsesGeoLayerTemplate),
  styleId: v.optional(v.union([v.string(), v.null()])),
  style: v.optional(v.unknown()),
  layerType: v.optional(vConnectMapsWebApiDtosEnumsGeoLayerType),
  fileVersionId: v.optional(v.union([v.string(), v.null()])),
  sourceLayerName: v.optional(v.union([v.string(), v.null()])),
  layerCreationStatus: v.optional(
    v.pipe(v.union([v.pipe(v.string(), v.readonly()), v.null()]), v.readonly())
  ),
  templatePublications: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoLayerTemplatePublication),
      v.null(),
    ])
  ),
  workspaces: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoLayerWorkspace),
      v.null(),
    ])
  ),
  isLockedInWorkspaces: v.optional(v.union([v.array(v.string()), v.null()])),
  symbol: v.optional(vConnectMapsWebApiDtosResponsesGeoLayerSymbol),
  styleOverrides: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoLayerStyleOverride),
      v.null(),
    ])
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoLayers = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoLayer), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoSymbol = v.strictObject({
  symbolDefinitionUuid: v.optional(v.pipe(v.string(), v.uuid())),
  type: v.optional(vConnectMapsWebApiDtosEnumsGeoSymbolType),
  geometryType: v.optional(vConnectMapsWebApiDtosTemplateGeoGeometryType),
  symbolName: v.optional(v.union([v.string(), v.null()])),
  svgImage: v.optional(v.union([v.string(), v.null()])),
  fillColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  outlineColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  text: v.optional(v.union([v.string(), v.null()])),
  color: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoStyle = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  image: v.optional(v.union([v.string(), v.null()])),
  lineColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  lineStyle: v.optional(v.union([v.string(), v.null()])),
  lineWeight: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  fillColor: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  fillOpacity: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  symbol: v.optional(vConnectMapsWebApiDtosResponsesGeoSymbol),
  styleOverrides: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoStyleOverride),
      v.null(),
    ])
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoStyles = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoStyle), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoSymbolDefinition =
  v.strictObject({
    uuid: v.optional(v.pipe(v.string(), v.uuid())),
    type: v.optional(vConnectMapsWebApiDtosEnumsGeoSymbolType),
    geometryType: v.optional(vConnectMapsWebApiDtosTemplateGeoGeometryType),
    symbolName: v.optional(v.union([v.string(), v.null()])),
    svgImage: v.optional(v.union([v.string(), v.null()])),
    createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    updatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoSymbolDefinitions =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoSymbolDefinition),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoSymbols = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoSymbol), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceTemplate =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    seriesId: v.optional(v.pipe(v.string(), v.uuid())),
    version: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    isPublished: v.optional(v.boolean()),
    templateName: v.optional(v.union([v.string(), v.null()])),
    geometryType: v.optional(vConnectMapsWebApiDtosTemplateGeoGeometryType),
    geometryColorHexRGB: v.optional(v.union([v.string(), v.null()])),
    isLocked: v.optional(v.union([v.boolean(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceLayer = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  name: v.optional(v.union([v.string(), v.null()])),
  sourceName: v.optional(v.union([v.string(), v.null()])),
  template: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceTemplate),
});

export const vConnectMapsWebApiDtosResponsesGeoWorkspace = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  description: v.optional(v.union([v.string(), v.null()])),
  connectFileId: v.optional(v.union([v.string(), v.null()])),
  connectFileError: v.optional(v.union([v.string(), v.null()])),
  uuid: v.optional(v.pipe(v.string(), v.uuid())),
  hasThumbnail: v.optional(v.boolean()),
  backgroundMapType: v.optional(
    vConnectMapsWebApiDtosEnumsGeoBackgroundMapType
  ),
  isDeleted: v.optional(v.boolean()),
  coordinateSystem: v.optional(
    vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystem
  ),
  bounds: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds),
  tectonicPlate: v.optional(v.union([v.string(), v.null()])),
  relationships: v.optional(
    vConnectMapsWebApiDtosResponsesGeoWorkspaceRelationships
  ),
  layers: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoWorkspaceLayer),
      v.null(),
    ])
  ),
  createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  updatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  publicationUpdatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  workspaceModel: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceModel),
  status: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus),
  postProcessingBody: v.optional(
    vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingBody
  ),
  type: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceType),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoWorkspaces = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoWorkspace), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosTemplateGeoTemplateStatus = v.picklist([
  'Draft',
  'Published',
]);

export const vConnectMapsWebApiDtosResponsesGeoTemplate = v.strictObject({
  seriesId: v.optional(v.pipe(v.string(), v.uuid())),
  version: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  template: v.optional(v.unknown()),
  isDeleted: v.optional(v.boolean()),
  isPublished: v.optional(v.union([v.boolean(), v.null()])),
  status: v.optional(vConnectMapsWebApiDtosTemplateGeoTemplateStatus),
  workspaces: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoTemplateWorkspace),
      v.null(),
    ])
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoTemplates = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoTemplate), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoTemplates_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosResponsesGeoTemplates),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoTemplates_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(
          vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoTemplates_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
        ),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosTemplateGroupModel = v.strictObject({
  uuid: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  displayName: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosTemplateLoggingMethod = v.picklist([
  'Automatic',
  'Manual',
]);

export const vConnectMapsWebApiDtosTemplateLoggingRateDistance = v.strictObject(
  {
    value: v.optional(v.union([v.number(), v.null()])),
    unit: v.optional(vConnectMapsWebApiDtosTemplateDistanceUnit),
    active: v.optional(v.boolean()),
  }
);

export const vConnectMapsWebApiDtosTemplateLoggingRateTime = v.strictObject({
  value: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  active: v.optional(v.boolean()),
});

export const vConnectMapsWebApiDtosTemplateLoggingRateModel = v.strictObject({
  time: v.optional(vConnectMapsWebApiDtosTemplateLoggingRateTime),
  distance: v.optional(vConnectMapsWebApiDtosTemplateLoggingRateDistance),
});

export const vConnectMapsWebApiDtosTemplateReviewModel = v.strictObject({
  line1FieldId: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  line2FieldId: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  thumbnailFieldId: v.optional(
    v.union([v.pipe(v.string(), v.uuid()), v.null()])
  ),
});

export const vConnectMapsWebApiDtosTemplateRuleRuleActionType = v.picklist([
  'EnableTarget',
  'DisableTarget',
]);

export const vConnectMapsWebApiDtosTemplateRuleRuleConditionType = v.picklist([
  'Other',
  'Text',
  'Number',
  'YesNo',
  'Date',
  'Choice',
]);

export const vConnectMapsWebApiDtosTemplateRuleRuleConditionBase =
  v.strictObject({
    sourceUuid: v.optional(v.pipe(v.string(), v.uuid())),
    type: v.optional(vConnectMapsWebApiDtosTemplateRuleRuleConditionType),
  });

export const vConnectMapsWebApiDtosTemplateRuleRuleTargetType = v.picklist([
  'Field',
  'Group',
]);

export const vConnectMapsWebApiDtosTemplateRuleRuleTarget = v.strictObject({
  type: v.optional(vConnectMapsWebApiDtosTemplateRuleRuleTargetType),
  targetUuid: v.optional(v.pipe(v.string(), v.uuid())),
  action: v.optional(vConnectMapsWebApiDtosTemplateRuleRuleActionType),
});

export const vConnectMapsWebApiDtosTemplateRuleRuleModel = v.strictObject({
  uuid: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  conditions: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosTemplateRuleRuleConditionBase),
      v.null(),
    ])
  ),
  targets: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosTemplateRuleRuleTarget), v.null()])
  ),
});

export const vConnectMapsWebApiDtosTemplateTemplateModel = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  geometryType: v.optional(vConnectMapsWebApiDtosTemplateGeoGeometryType),
  geometryColorHexRGB: v.optional(v.union([v.string(), v.null()])),
  geometryCollectionRequired: v.optional(v.boolean()),
  accuracyLimit: v.optional(v.number()),
  allowOverrideForAccuracyLimit: v.optional(v.boolean()),
  lockedSchema: v.optional(v.boolean()),
  fields: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosTemplateFieldModelBase), v.null()])
  ),
  groups: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosTemplateGroupModel), v.null()])
  ),
  rules: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosTemplateRuleRuleModel), v.null()])
  ),
  review: v.optional(vConnectMapsWebApiDtosTemplateReviewModel),
  useSeparateUpdateWorkflow: v.optional(v.boolean()),
  repeatFieldsAutomatically: v.optional(v.union([v.boolean(), v.null()])),
  status: v.optional(vConnectMapsWebApiDtosTemplateGeoTemplateStatus),
  vertexNumberOfPositions: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  loggingRate: v.optional(vConnectMapsWebApiDtosTemplateLoggingRateModel),
  loggingMethod: v.optional(vConnectMapsWebApiDtosTemplateLoggingMethod),
  allowDigitizedPositions: v.optional(v.boolean()),
  enableSymbols: v.optional(v.boolean()),
  enableAttributedSymbols: v.optional(v.boolean()),
});

export const vConnectMapsWebApiDtosRequestsGeoPostTemplateRequest =
  v.strictObject({
    template: v.optional(vConnectMapsWebApiDtosTemplateTemplateModel),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutTemplateRequest =
  v.strictObject({
    template: v.optional(vConnectMapsWebApiDtosTemplateTemplateModel),
  });

export const vConnectMapsWebApiDtosRequestsGeoWorkspaceContent = v.strictObject(
  {
    layer: v.optional(vConnectMapsWebApiDtosRequestsGeoPostLayerRequest),
    style: v.optional(vConnectMapsWebApiDtosRequestsGeoPostStyleRequest),
    template: v.optional(vConnectMapsWebApiDtosRequestsGeoPostTemplateRequest),
    symbol: v.optional(vConnectMapsWebApiDtosRequestsGeoPostSymbolRequest),
    styleOverrides: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosRequestsGeoPostStyleOverrideRequest),
        v.null(),
      ])
    ),
  }
);

export const vConnectMapsWebApiDtosRequestsGeoPostImportWorkspaceRequest =
  v.strictObject({
    workspace: v.optional(
      vConnectMapsWebApiDtosRequestsGeoPostWorkspaceRequest
    ),
    content: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosRequestsGeoWorkspaceContent),
        v.null(),
      ])
    ),
  });

export const vTrimbleGeospatialFeaturesApiAggregationOperator = v.picklist([
  'Max',
  'Min',
  'GeoBounds',
  'Count',
  'Distinct',
]);

export const vTrimbleGeospatialFeaturesApiClause = v.strictObject({});

export const vConnectMapsWebApiDtosRequestsGeoGetAggregationRequest =
  v.strictObject({
    operator: v.optional(vTrimbleGeospatialFeaturesApiAggregationOperator),
    field: v.optional(v.union([v.string(), v.null()])),
    filter: v.optional(
      v.union([v.array(vTrimbleGeospatialFeaturesApiClause), v.null()])
    ),
  });

export const vTrimbleGeospatialFeaturesApiCoerceType = v.picklist([
  'Text',
  'Number',
  'DateTime',
]);

export const vTrimbleGeospatialFeaturesApiCoordinateType = v.picklist([
  'Original',
  'Local',
  'Global',
]);

export const vTrimbleGeospatialFeaturesApiGeometry = v.strictObject({
  type: v.optional(
    v.pipe(v.union([v.pipe(v.string(), v.readonly()), v.null()]), v.readonly())
  ),
});

export const vTrimbleGeospatialFeaturesApiProperty = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
});

export const vTrimbleGeospatialFeaturesApiNamedCrs = v.strictObject({
  type: v.optional(
    v.pipe(v.union([v.pipe(v.string(), v.readonly()), v.null()]), v.readonly())
  ),
  properties: v.optional(vTrimbleGeospatialFeaturesApiProperty),
});

export const vConnectMapsWebApiDtosRequestsGeoPatchFormRequest = v.strictObject(
  {
    geometry: v.optional(vTrimbleGeospatialFeaturesApiGeometry),
    properties: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    metadata: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
    crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrs),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
  }
);

export const vConnectMapsWebApiDtosRequestsGeoBatchPatchRequest1ConnectMapsWebApiDtosRequestsGeoPatchFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosRequestsGeoPatchFormRequest),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostFormRequest = v.strictObject({
  id: v.optional(v.union([v.string(), v.null()])),
  geometry: v.optional(vTrimbleGeospatialFeaturesApiGeometry),
  properties: v.optional(
    v.union([v.record(v.string(), v.unknown()), v.null()])
  ),
  metadata: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrs),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
});

export const vConnectMapsWebApiDtosRequestsGeoBatchPostRequest1ConnectMapsWebApiDtosRequestsGeoPostFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostFormRequest),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutFormRequest = v.strictObject({
  geometry: v.optional(vTrimbleGeospatialFeaturesApiGeometry),
  properties: v.optional(
    v.union([v.record(v.string(), v.unknown()), v.null()])
  ),
  metadata: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrs),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
});

export const vConnectMapsWebApiDtosRequestsGeoBatchPutRequest1ConnectMapsWebApiDtosRequestsGeoPutFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutFormRequest),
  });

export const vConnectMapsWebApiDtosResponsesGeoForm = v.strictObject({
  geometry: v.optional(vTrimbleGeospatialFeaturesApiGeometry),
  properties: v.optional(
    v.union([v.record(v.string(), v.unknown()), v.null()])
  ),
  metadata: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrs),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosResponsesGeoForm),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(
          vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
        ),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoFormVersion = v.strictObject({
  version: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  geometry: v.optional(vTrimbleGeospatialFeaturesApiGeometry),
  properties: v.optional(
    v.union([v.record(v.string(), v.unknown()), v.null()])
  ),
  metadata: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrs),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoFormVersions = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoFormVersion), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoFormVersions_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosResponsesGeoFormVersions),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoFormVersions_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(
          vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoFormVersions_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
        ),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoQueryForms = v.strictObject({
  scrollId: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  startIndex: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  pageSize: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosResponsesGeoForm), v.null()])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vTrimbleGeospatialFeaturesApiSortOrder = v.picklist([
  'Ascending',
  'Descending',
]);

export const vTrimbleGeospatialFeaturesApiSortBy = v.strictObject({
  field: v.optional(v.union([v.string(), v.null()])),
  order: v.optional(vTrimbleGeospatialFeaturesApiSortOrder),
  type: v.optional(vTrimbleGeospatialFeaturesApiCoerceType),
});

export const vConnectMapsWebApiDtosRequestsGeoQueryFormRequest = v.strictObject(
  {
    filter: v.optional(
      v.union([v.array(vTrimbleGeospatialFeaturesApiClause), v.null()])
    ),
    sortBy: v.optional(
      v.union([v.array(vTrimbleGeospatialFeaturesApiSortBy), v.null()])
    ),
    fields: v.optional(v.union([v.array(v.string()), v.null()])),
    crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrs),
    scrollId: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  }
);

export const vTrimbleGeospatialFeaturesApiQuery = v.strictObject({
  filter: v.optional(
    v.union([v.array(vTrimbleGeospatialFeaturesApiClause), v.null()])
  ),
  sortBy: v.optional(
    v.union([v.array(vTrimbleGeospatialFeaturesApiSortBy), v.null()])
  ),
  fields: v.optional(v.union([v.array(v.string()), v.null()])),
  coordinateType: v.optional(vTrimbleGeospatialFeaturesApiCoordinateType),
  initialScrolledRequestCrs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrs),
  includeSchema: v.optional(v.boolean()),
  startIndex: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  pageSize: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
});

export const vConnectMapsWebApiDtosGeoExport = v.strictObject({
  name: v.optional(v.union([v.pipe(v.string(), v.maxLength(60)), v.null()])),
  emailAddress: v.optional(v.union([v.string(), v.null()])),
  exportFormat: v.optional(vConnectMapsWebApiDtosEnumsGeoExportFormat),
  query: v.optional(vTrimbleGeospatialFeaturesApiQuery),
  exportSRS: v.optional(v.union([v.string(), v.null()])),
  imagesAsHyperlinks: v.optional(v.boolean()),
  markAsExported: v.optional(v.boolean()),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
  pdfTemplateConnectFileId: v.optional(v.union([v.string(), v.null()])),
  pdfExportNameFieldName: v.optional(v.union([v.string(), v.null()])),
  useLatestTemplate: v.optional(v.boolean()),
  workspaceId: v.optional(v.union([v.string(), v.null()])),
  useCodedChoiceDescription: v.optional(v.boolean()),
});

export const vConnectMapsWebApiDtosRequestsGeoPostExportJobRequest =
  v.strictObject({
    geoExportBody: v.optional(vConnectMapsWebApiDtosGeoExport),
  });

export const vConnectMapsApiClientContractsDtosConnectFileWritable =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    name: v.optional(v.union([v.string(), v.null()])),
    type: v.optional(v.union([v.string(), v.null()])),
    versionId: v.optional(v.union([v.string(), v.null()])),
    parentId: v.optional(v.union([v.string(), v.null()])),
    createdBy: v.optional(vConnectMapsApiClientContractsDtosPersonInfo),
    modifiedBy: v.optional(vConnectMapsApiClientContractsDtosPersonInfo),
    thumbnailUrl: v.optional(v.union([v.array(v.string()), v.null()])),
    size: v.optional(v.union([v.string(), v.null()])),
    projectId: v.optional(v.union([v.string(), v.null()])),
    createdOn: v.optional(v.union([v.string(), v.null()])),
    modifiedOn: v.optional(v.union([v.string(), v.null()])),
    hash: v.optional(v.union([v.string(), v.null()])),
    revision: v.optional(v.union([v.string(), v.null()])),
    status: v.optional(v.union([v.string(), v.null()])),
    hidden: v.optional(v.boolean()),
    path: v.optional(
      v.union([v.array(vConnectMapsApiClientContractsDtosPathLevel), v.null()])
    ),
  });

export const vConnectMapsApiClientContractsDtosPrivateConnectFileWritable =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    etag: v.optional(v.union([v.string(), v.null()])),
    name: v.optional(v.union([v.string(), v.null()])),
    projectId: v.optional(v.union([v.string(), v.null()])),
    parentEtagId: v.optional(v.union([v.string(), v.null()])),
    parentId: v.optional(v.union([v.string(), v.null()])),
    hasChildren: v.optional(v.boolean()),
    type: v.optional(v.union([v.string(), v.null()])),
    modified: v.optional(v.number()),
    createdOn: v.optional(v.number()),
    size: v.optional(v.union([v.string(), v.null()])),
    contentStorageObjectId: v.optional(v.union([v.string(), v.null()])),
    hidden: v.optional(v.boolean()),
    path: v.optional(
      v.union([v.array(vConnectMapsApiClientContractsDtosPathLevel), v.null()])
    ),
  });

export const vConnectMapsWebApiDtosGeoMapCacheBodyWritable = v.strictObject({
  name: v.optional(v.union([v.string(), v.null()])),
  wgs84LatitudeNorth: v.optional(v.number()),
  wgs84LatitudeSouth: v.optional(v.number()),
  wgs84LongitudeEast: v.optional(v.number()),
  wgs84LongitudeWest: v.optional(v.number()),
  zoomLevel: v.optional(v.union([v.string(), v.null()])),
  baseMapStyle: v.optional(vConnectMapsWebApiDtosGeoBaseMapStyle),
});

export const vConnectMapsWebApiDtosRequestsGeoPostMapCacheRequestWritable =
  v.strictObject({
    geoMapCacheBody: v.optional(vConnectMapsWebApiDtosGeoMapCacheBodyWritable),
  });

export const vConnectMapsWebApiDtosResponsesGeoLayerWritable = v.strictObject({
  layerName: v.optional(v.union([v.string(), v.null()])),
  template: v.optional(vConnectMapsWebApiDtosResponsesGeoLayerTemplate),
  styleId: v.optional(v.union([v.string(), v.null()])),
  style: v.optional(v.unknown()),
  layerType: v.optional(vConnectMapsWebApiDtosEnumsGeoLayerType),
  fileVersionId: v.optional(v.union([v.string(), v.null()])),
  sourceLayerName: v.optional(v.union([v.string(), v.null()])),
  templatePublications: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoLayerTemplatePublication),
      v.null(),
    ])
  ),
  workspaces: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoLayerWorkspace),
      v.null(),
    ])
  ),
  isLockedInWorkspaces: v.optional(v.union([v.array(v.string()), v.null()])),
  symbol: v.optional(vConnectMapsWebApiDtosResponsesGeoLayerSymbol),
  styleOverrides: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoLayerStyleOverride),
      v.null(),
    ])
  ),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoLayersWritable = v.strictObject({
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  total: v.optional(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
      v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
    )
  ),
  items: v.optional(
    v.union([
      v.array(vConnectMapsWebApiDtosResponsesGeoLayerWritable),
      v.null(),
    ])
  ),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystemWritable =
  v.strictObject({
    zoneGroupComponentId: v.optional(v.union([v.string(), v.null()])),
    zoneComponentId: v.optional(v.union([v.string(), v.null()])),
    datumComponentId: v.optional(v.union([v.string(), v.null()])),
    geoidComponentId: v.optional(v.union([v.string(), v.null()])),
    localReferenceFrameComponentId: v.optional(v.union([v.string(), v.null()])),
    horizontalUnit: v.optional(vConnectMapsWebApiDtosEnumsGeoLinearUnit),
    verticalUnit: v.optional(vConnectMapsWebApiDtosEnumsGeoLinearUnit),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostDuplicateWorkspaceRequestWritable =
  v.strictObject({
    sourceWorkspaceId: v.optional(v.union([v.string(), v.null()])),
    name: v.optional(v.union([v.pipe(v.string(), v.maxLength(44)), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    use_Source_CoordinationSystem: v.optional(v.boolean()),
    duplicationMethod: v.optional(
      vConnectMapsWebApiDtosRequestsDuplicateTemplateMethod
    ),
    coordinateSystem: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystemWritable
    ),
    bounds: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds),
    enablePostProcessing: v.optional(v.boolean()),
    connectFolderId: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostWorkspaceRequestWritable =
  v.strictObject({
    name: v.optional(v.union([v.pipe(v.string(), v.maxLength(44)), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    connectFileId: v.optional(v.union([v.string(), v.null()])),
    connectFolderId: v.optional(v.union([v.string(), v.null()])),
    backgroundMapType: v.optional(
      vConnectMapsWebApiDtosEnumsGeoBackgroundMapType
    ),
    coordinateSystem: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystemWritable
    ),
    bounds: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds),
    postProcessingBody: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingBody
    ),
    tectonicPlate: v.optional(v.union([v.string(), v.null()])),
    workspaceModel: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceModel
    ),
    type: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceType),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostImportWorkspaceRequestWritable =
  v.strictObject({
    workspace: v.optional(
      vConnectMapsWebApiDtosRequestsGeoPostWorkspaceRequestWritable
    ),
    content: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosRequestsGeoWorkspaceContent),
        v.null(),
      ])
    ),
  });

export const vConnectMapsWebApiDtosResponsesGeoWorkspaceWritable =
  v.strictObject({
    name: v.optional(v.union([v.string(), v.null()])),
    description: v.optional(v.union([v.string(), v.null()])),
    connectFileId: v.optional(v.union([v.string(), v.null()])),
    connectFileError: v.optional(v.union([v.string(), v.null()])),
    uuid: v.optional(v.pipe(v.string(), v.uuid())),
    hasThumbnail: v.optional(v.boolean()),
    backgroundMapType: v.optional(
      vConnectMapsWebApiDtosEnumsGeoBackgroundMapType
    ),
    isDeleted: v.optional(v.boolean()),
    coordinateSystem: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceCoordinateSystemWritable
    ),
    bounds: v.optional(vConnectMapsWebApiDtosResponsesGeoWorkspaceBounds),
    tectonicPlate: v.optional(v.union([v.string(), v.null()])),
    relationships: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceRelationships
    ),
    layers: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoWorkspaceLayer),
        v.null(),
      ])
    ),
    createdUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    updatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    publicationUpdatedUtc: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    workspaceModel: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspaceModel
    ),
    status: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus),
    postProcessingBody: v.optional(
      vConnectMapsWebApiDtosResponsesGeoWorkspacePostProcessingBody
    ),
    type: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceType),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoWorkspacesWritable =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoWorkspaceWritable),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vTrimbleGeospatialFeaturesApiNamedCrsWritable = v.strictObject({
  properties: v.optional(vTrimbleGeospatialFeaturesApiProperty),
});

export const vConnectMapsWebApiDtosRequestsGeoPatchFormRequestWritable =
  v.strictObject({
    properties: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    metadata: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
    crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrsWritable),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoBatchPatchRequest1ConnectMapsWebApiDtosRequestsGeoPatchFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_nullWritable =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosRequestsGeoPatchFormRequestWritable),
  });

export const vConnectMapsWebApiDtosRequestsGeoPostFormRequestWritable =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    properties: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    metadata: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
    crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrsWritable),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoBatchPostRequest1ConnectMapsWebApiDtosRequestsGeoPostFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_nullWritable =
  v.strictObject({
    body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostFormRequestWritable),
  });

export const vConnectMapsWebApiDtosRequestsGeoPutFormRequestWritable =
  v.strictObject({
    properties: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    metadata: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
    crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrsWritable),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
  });

export const vConnectMapsWebApiDtosRequestsGeoBatchPutRequest1ConnectMapsWebApiDtosRequestsGeoPutFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_nullWritable =
  v.strictObject({
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutFormRequestWritable),
  });

export const vConnectMapsWebApiDtosRequestsGeoQueryFormRequestWritable =
  v.strictObject({
    filter: v.optional(
      v.union([v.array(vTrimbleGeospatialFeaturesApiClause), v.null()])
    ),
    sortBy: v.optional(
      v.union([v.array(vTrimbleGeospatialFeaturesApiSortBy), v.null()])
    ),
    fields: v.optional(v.union([v.array(v.string()), v.null()])),
    crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrsWritable),
    scrollId: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoFormWritable = v.strictObject({
  properties: v.optional(
    v.union([v.record(v.string(), v.unknown()), v.null()])
  ),
  metadata: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
  crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrsWritable),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
  links: v.optional(
    v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
  ),
  id: v.optional(v.union([v.string(), v.null()])),
  eTag: v.optional(v.union([v.string(), v.null()])),
});

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_nullWritable =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosResponsesGeoFormWritable),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoFormVersionWritable =
  v.strictObject({
    version: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    properties: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    metadata: v.optional(
      v.union([v.record(v.string(), v.unknown()), v.null()])
    ),
    schema: v.optional(v.union([v.record(v.string(), v.unknown()), v.null()])),
    crs: v.optional(vTrimbleGeospatialFeaturesApiNamedCrsWritable),
    tags: v.optional(v.union([v.array(v.string()), v.null()])),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoFormVersionsWritable =
  v.strictObject({
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoFormVersionWritable),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoBatchResponse1ConnectMapsWebApiDtosResponsesGeoFormVersions_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_nullWritable =
  v.strictObject({
    status: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    reason: v.optional(v.union([v.string(), v.null()])),
    body: v.optional(vConnectMapsWebApiDtosResponsesGeoFormVersionsWritable),
    error: v.optional(vConnectMapsWebApiDtosResponsesGeoError),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    id: v.optional(v.union([v.string(), v.null()])),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vConnectMapsWebApiDtosResponsesGeoQueryFormsWritable =
  v.strictObject({
    scrollId: v.optional(v.union([v.pipe(v.string(), v.uuid()), v.null()])),
    startIndex: v.optional(
      v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.null(),
      ])
    ),
    pageSize: v.optional(
      v.union([
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        v.null(),
      ])
    ),
    links: v.optional(
      v.union([v.array(vConnectMapsWebApiDtosBaseGeoLink), v.null()])
    ),
    total: v.optional(
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      )
    ),
    items: v.optional(
      v.union([
        v.array(vConnectMapsWebApiDtosResponsesGeoFormWritable),
        v.null(),
      ])
    ),
    eTag: v.optional(v.union([v.string(), v.null()])),
  });

export const vTrimbleGeospatialFeaturesApiQueryWritable = v.strictObject({
  filter: v.optional(
    v.union([v.array(vTrimbleGeospatialFeaturesApiClause), v.null()])
  ),
  sortBy: v.optional(
    v.union([v.array(vTrimbleGeospatialFeaturesApiSortBy), v.null()])
  ),
  fields: v.optional(v.union([v.array(v.string()), v.null()])),
  coordinateType: v.optional(vTrimbleGeospatialFeaturesApiCoordinateType),
  initialScrolledRequestCrs: v.optional(
    vTrimbleGeospatialFeaturesApiNamedCrsWritable
  ),
  includeSchema: v.optional(v.boolean()),
  startIndex: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
  pageSize: v.optional(
    v.union([
      v.pipe(
        v.number(),
        v.integer(),
        v.minValue(-2147483648, 'Invalid value: Expected int32 to be >= -2^31'),
        v.maxValue(2147483647, 'Invalid value: Expected int32 to be <= 2^31-1')
      ),
      v.null(),
    ])
  ),
});

export const vConnectMapsWebApiDtosGeoExportWritable = v.strictObject({
  name: v.optional(v.union([v.pipe(v.string(), v.maxLength(60)), v.null()])),
  emailAddress: v.optional(v.union([v.string(), v.null()])),
  exportFormat: v.optional(vConnectMapsWebApiDtosEnumsGeoExportFormat),
  query: v.optional(vTrimbleGeospatialFeaturesApiQueryWritable),
  exportSRS: v.optional(v.union([v.string(), v.null()])),
  imagesAsHyperlinks: v.optional(v.boolean()),
  markAsExported: v.optional(v.boolean()),
  tags: v.optional(v.union([v.array(v.string()), v.null()])),
  pdfTemplateConnectFileId: v.optional(v.union([v.string(), v.null()])),
  pdfExportNameFieldName: v.optional(v.union([v.string(), v.null()])),
  useLatestTemplate: v.optional(v.boolean()),
  workspaceId: v.optional(v.union([v.string(), v.null()])),
  useCodedChoiceDescription: v.optional(v.boolean()),
});

export const vConnectMapsWebApiDtosRequestsGeoPostExportJobRequestWritable =
  v.strictObject({
    geoExportBody: v.optional(vConnectMapsWebApiDtosGeoExportWritable),
  });

export const vAnnouncementsTrackingPostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoAnnouncementsTrackingRequest
  ),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vAnnouncementsTrackingPostResponse =
  vConnectMapsWebApiDtosResponsesGeoAnnouncement;

export const vAnnouncementsGetData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      conditions: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vAnnouncementsGetResponse =
  vConnectMapsWebApiDtosResponsesGeoAnnouncements;

export const vRevokeTokenData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      token: v.optional(v.string()),
    })
  ),
});

export const vGetAuthCurrentuserData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vGetAuthCurrentuserResponse =
  vConnectMapsWebApiDtosResponsesGeoUser;

export const vDataUpdateJobListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      WorkspaceId: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
      includeTodo: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vDataUpdateJobListResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJobs;

export const vDataUpdateJobPostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostDataUpdateJobRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vDataUpdateJobPostResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJob;

export const vDataUpdateJobDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vDataUpdateJobGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeTodo: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vDataUpdateJobGetResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJob;

export const vDataUpdateJobPatchData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPatchDataUpdateJobRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vDataUpdateJobPatchResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJob;

export const vDataUpdateJobPutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutDataUpdateJobRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vDataUpdateJobPutResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJob;

export const vDataUpdateJobGetByTodoIdData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    todoId: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeTodo: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vDataUpdateJobGetByTodoIdResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJob;

export const vDataUpdateJobQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includes: v.optional(v.string()),
      excludes: v.optional(v.string()),
      filter: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
      includeTodo: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vDataUpdateJobQueryResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJobs;

export const vDataUpdateJobSearchData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      workspaceId: v.optional(v.string()),
      status: v.optional(
        vConnectMapsWebApiDtosEnumsGeoRequestDataUpdateJobStatus
      ),
      title: v.optional(v.string()),
      pageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        100
      ),
    })
  ),
});

/**
 * OK
 */
export const vDataUpdateJobSearchResponse =
  vConnectMapsWebApiDtosResponsesGeoDataUpdateJobs;

export const vReturnJobDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vReturnJobListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vReturnJobListResponse =
  vConnectMapsWebApiDtosResponsesGeoReturnedJobs;

export const vReturnJobPostData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vReturnJobPostResponse =
  vConnectMapsWebApiDtosResponsesGeoReturnedJob;

export const vReturnJobGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    returnId: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vReturnJobGetResponse =
  vConnectMapsWebApiDtosResponsesGeoReturnedJob;

export const vEntitlementActivationsGetData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      current: v.optional(v.boolean(), true),
      sku: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vEntitlementActivationsGetResponse = v.array(
  vConnectMapsWebApiDtosResponsesGeoUserActivation
);

export const vExportJobListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vExportJobListResponse =
  vConnectMapsWebApiDtosResponsesGeoExportJobs;

export const vExportJobPostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostExportJobRequestWritable
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vExportJobPostResponse =
  vConnectMapsWebApiDtosResponsesGeoExportJob;

export const vExportJobGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vExportJobGetResponse =
  vConnectMapsWebApiDtosResponsesGeoExportJob;

export const vExportJobGetDownloadUrlData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

export const vExportJobQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      deletedItems: v.optional(v.boolean(), false),
      sortBy: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vExportJobQueryResponse =
  vConnectMapsWebApiDtosResponsesGeoExportJobs;

export const vGetprepareddataData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      s3ObjectKey: v.optional(v.string()),
    })
  ),
});

export const vFlagDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      name: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vFlagDeleteResponse = vConnectMapsWebApiDtosGeoFeatureFlag;

export const vFlagsGetData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vFlagsGetResponse = v.array(vConnectMapsWebApiDtosGeoFeatureFlag);

export const vFlagPostData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      name: v.optional(v.string()),
      enabled: v.optional(v.boolean(), false),
    })
  ),
});

/**
 * OK
 */
export const vFlagPostResponse = vConnectMapsWebApiDtosGeoFeatureFlag;

export const vFlagPutData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      name: v.optional(v.string()),
      enabled: v.optional(v.boolean(), false),
    })
  ),
});

/**
 * OK
 */
export const vFlagPutResponse = vConnectMapsWebApiDtosGeoFeatureFlag;

export const vFeatureImageGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    imageId: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(
    v.object({
      oid: v.optional(
        v.pipe(
          v.union([v.number(), v.string(), v.bigint()]),
          v.transform((x) => BigInt(x)),
          v.minValue(
            BigInt('-9223372036854775808'),
            'Invalid value: Expected int64 to be >= -2^63'
          ),
          v.maxValue(
            BigInt('9223372036854775807'),
            'Invalid value: Expected int64 to be <= 2^63-1'
          )
        )
      ),
      hash: v.optional(v.string()),
      thumbnail: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vFeatureImageGetResponse = v.string();

export const vImportJobGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      workspaceId: v.optional(v.string()),
      fetchInprogressJobsOnly: v.optional(v.boolean(), true),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vImportJobGetResponse =
  vConnectMapsWebApiDtosResponsesGeoFeautreImportJobs;

export const vImportJobPostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostFeaturesImportJobRequest
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vImportJobPostResponse =
  vConnectMapsWebApiDtosResponsesGeoFeautreImportJob;

export const vImportJobSelectData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    importId: v.pipe(v.string(), v.uuid()),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vImportJobSelectResponse =
  vConnectMapsWebApiDtosResponsesGeoFeautreImportJob;

export const vFieldGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vFieldGetResponse = vConnectMapsWebApiDtosResponsesGeoField;

export const vFieldListData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      Type: v.optional(v.string()),
      Category: v.optional(v.string()),
      Subcategory: v.optional(v.string()),
      FieldCategory: v.optional(v.string()),
      IsDefault: v.optional(v.boolean()),
      sortBy: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vFieldListResponse = vConnectMapsWebApiDtosResponsesGeoFields;

export const vFieldQueryData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vFieldQueryResponse = vConnectMapsWebApiDtosResponsesGeoFields;

export const vFormImageGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    imageId: v.pipe(v.string(), v.uuid()),
  }),
  query: v.optional(
    v.object({
      projectId: v.optional(v.string()),
      hash: v.optional(v.string()),
      thumbnail: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vFormImageGetResponse = v.string();

export const vFormPostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostFormRequestWritable),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vFormPostResponse = vConnectMapsWebApiDtosResponsesGeoForm;

export const vFormDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vFormDeleteResponse =
  vConnectMapsWebApiDtosResponsesGeoDeleteStatus;

export const vFormGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vFormGetResponse = vConnectMapsWebApiDtosResponsesGeoForm;

export const vFormPatchData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPatchFormRequestWritable),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vFormPatchResponse = vConnectMapsWebApiDtosResponsesGeoForm;

export const vFormPutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutFormRequestWritable),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vFormPutResponse = vConnectMapsWebApiDtosResponsesGeoForm;

export const vFormGetVersionsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      latestOnly: v.optional(v.boolean()),
      crsName: v.optional(v.string()),
      includeSchema: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vFormGetVersionsResponse =
  vConnectMapsWebApiDtosResponsesGeoQueryForms;

export const vFormAggregationsData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoGetAggregationRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vFormQueryData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoQueryFormRequestWritable),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeSchema: v.optional(v.boolean(), false),
      pageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        0
      ),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
});

export const vFormQueryResponse = v.union([
  vConnectMapsWebApiDtosResponsesGeoQueryForms,
  v.void(),
]);

export const vBatchFormPostData = v.object({
  body: v.optional(
    v.array(
      vConnectMapsWebApiDtosRequestsGeoBatchPostRequest1ConnectMapsWebApiDtosRequestsGeoPostFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
    )
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vBatchFormPostResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vBatchFormPutData = v.object({
  body: v.optional(
    v.array(
      vConnectMapsWebApiDtosRequestsGeoBatchPutRequest1ConnectMapsWebApiDtosRequestsGeoPutFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
    )
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vBatchFormPutResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vBatchFormPatchData = v.object({
  body: v.optional(
    v.array(
      vConnectMapsWebApiDtosRequestsGeoBatchPatchRequest1ConnectMapsWebApiDtosRequestsGeoPatchFormRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
    )
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      echo: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vBatchFormPatchResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vBatchFormGetVersionsData = v.object({
  body: v.optional(v.array(vConnectMapsWebApiDtosRequestsGeoBatchGetRequest)),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      crsName: v.optional(v.string()),
      includeSchema: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vBatchFormGetVersionsResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoFormVersions_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vBatchFormGetData = v.object({
  body: v.optional(v.array(vConnectMapsWebApiDtosRequestsGeoBatchGetRequest)),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      crsName: v.optional(v.string()),
      includeSchema: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vBatchFormGetResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoForm_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vBatchFormDeleteData = v.object({
  body: v.optional(
    v.array(vConnectMapsWebApiDtosRequestsGeoBatchDeleteRequest)
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vBatchFormDeleteResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoDeleteStatus_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vBatchFormAggregationsData = v.object({
  body: v.optional(
    v.array(vConnectMapsWebApiDtosRequestsGeoGetAggregationRequest)
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vBatchFormAggregationsResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1SystemObject_SystemPrivateCoreLib_Version_8000_Culture_neutral_PublicKeyToken_7Cec85D7Bea7798E;

export const vGisJobPostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGisJobGeoPostGisJobRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vGisJobPostResponse =
  vConnectMapsWebApiDtosResponsesGisJobGeoGisJob;

export const vGisJobDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vGisJobGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vGisJobGetResponse =
  vConnectMapsWebApiDtosResponsesGisJobGeoGisJob;

export const vGisJobPatchData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGisJobGeoPatchGisJobRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.object({
    'If-Match': v.string(),
  }),
});

/**
 * OK
 */
export const vGisJobPatchResponse =
  vConnectMapsWebApiDtosResponsesGisJobGeoGisJob;

export const vGisJobQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      workspaceStatus: v.optional(
        vConnectMapsWebApiDtosEnumsGeoWorkspaceStatus
      ),
      fields: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      pageIndex: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        0
      ),
      pageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        100
      ),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vGisJobQueryResponse =
  vConnectMapsWebApiDtosResponsesGisJobGeoGisJob;

export const vGisReturnJobDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.object({
    'If-Match': v.string(),
  }),
});

export const vGisReturnJobListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vGisReturnJobListResponse =
  vConnectMapsWebApiDtosResponsesGeoReturnedJobs;

export const vGisReturnJobPostData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.object({
    'If-Match': v.string(),
  }),
});

/**
 * OK
 */
export const vGisReturnJobPostResponse =
  vConnectMapsWebApiDtosResponsesGeoReturnedJob;

export const vProjectImagePostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostImageRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vProjectImagePostResponse =
  vConnectMapsWebApiDtosResponsesGeoImageObject;

export const vProjectImageDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    uuid: v.pipe(v.string(), v.uuid()),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vProjectImageGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    uuid: v.pipe(v.string(), v.uuid()),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vProjectImageGetResponse =
  vConnectMapsWebApiDtosResponsesGeoImageObject;

export const vLayerListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      WorkspaceId: v.optional(v.string()),
      DatumComponentId: v.optional(v.string()),
      FileVersionId: v.optional(v.string()),
      TemplateSeriesId: v.optional(v.pipe(v.string(), v.uuid())),
      TemplateId: v.optional(v.string()),
      Name: v.optional(v.string()),
      IsDeleted: v.optional(v.boolean()),
      LayerTypes: v.optional(v.array(vConnectMapsWebApiDtosEnumsGeoLayerType)),
      sortBy: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerListResponse = vConnectMapsWebApiDtosResponsesGeoLayers;

export const vLayerPostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostLayerRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vLayerPostResponse = vConnectMapsWebApiDtosResponsesGeoLayer;

export const vLayerGetTemplateData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerGetTemplateResponse =
  vConnectMapsWebApiDtosTemplateTemplateModel;

export const vLayerDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vLayerGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerGetResponse = vConnectMapsWebApiDtosResponsesGeoLayer;

export const vLayerPutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutLayerRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerPutResponse = vConnectMapsWebApiDtosResponsesGeoLayer;

export const vLayerQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      deletedItems: v.optional(v.boolean(), false),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerQueryResponse = vConnectMapsWebApiDtosResponsesGeoLayers;

export const vLayerPutAutoincrementData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerPutAutoincrementResponse =
  vConnectMapsWebApiDtosResponsesGeoLayerAutoincrementResult;

export const vBatchLayerPutAutoincrementData = v.object({
  body: v.optional(v.array(v.string())),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vBatchLayerPutAutoincrementResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoLayerAutoincrementResult_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vLayerRelationshipsPatchData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPatchLayerRelationshipsRequest
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerRelationshipsPatchResponse =
  vConnectMapsWebApiDtosResponsesGeoLayer;

export const vLayerRelationshipsCreateData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoCreateLayerRelationshipsRequest
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vLayerRelationshipsCreateResponse =
  vConnectMapsWebApiDtosResponsesGeoLayer;

export const vMapCacheListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      WorkspaceId: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vMapCacheListResponse =
  vConnectMapsWebApiDtosResponsesGeoMapCaches;

export const vMapCachePostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostMapCacheRequestWritable
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vMapCachePostResponse = vConnectMapsWebApiDtosResponsesGeoMapCache;

export const vMapCacheDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vMapCacheGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vMapCacheGetResponse = vConnectMapsWebApiDtosResponsesGeoMapCache;

export const vMapCachePatchData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPatchMapCacheRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vMapCachePatchResponse =
  vConnectMapsWebApiDtosResponsesGeoMapCache;

export const vMapCacheQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      deletedItems: v.optional(v.boolean(), false),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vMapCacheQueryResponse =
  vConnectMapsWebApiDtosResponsesGeoMapCaches;

export const vMapCacheGetDownloadUrlData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    jobToken: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vMapCacheGetDownloadUrlResponse = v.string();

export const vListTcProjectsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vListTcProjectsResponse =
  vConnectMapsWebApiDtosResponsesGeoProjects;

export const vUserListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vUserListResponse = vConnectMapsWebApiDtosResponsesGeoUserProfiles;

export const vGroupListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vGroupListResponse = vConnectMapsWebApiDtosResponsesGeoGroups;

export const vSpatialFileGetByIdData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
    fileId: v.string(),
  }),
  query: v.optional(
    v.object({
      versionId: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vSpatialFileGetByIdResponse =
  vConnectMapsApiClientContractsDtosConnectFile;

export const vSpatialFileListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vSpatialFileListResponse = v.array(
  vConnectMapsApiClientContractsDtosPrivateConnectFile
);

export const vGetMembershipData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      userId: v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vGetMembershipResponse =
  vConnectMapsWebApiDtosResponsesGeoUserProfile;

export const vRealtimeCorrectionListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      WorkspaceId: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vRealtimeCorrectionListResponse =
  vConnectMapsWebApiDtosResponsesGeoRealtimeCorrections;

export const vRealtimeCorrectionPostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostRealtimeCorrectionRequest
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vRealtimeCorrectionPostResponse =
  vConnectMapsWebApiDtosResponsesGeoRealtimeCorrection;

export const vRealtimeCorrectionDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vRealtimeCorrectionGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vRealtimeCorrectionGetResponse =
  vConnectMapsWebApiDtosResponsesGeoRealtimeCorrection;

export const vRealtimeCorrectionPutData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPutRealtimeCorrectionRequest
  ),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vRealtimeCorrectionPutResponse =
  vConnectMapsWebApiDtosResponsesGeoRealtimeCorrection;

export const vDatumsListData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      proximityLatitude: v.optional(v.number()),
      proximityLongitude: v.optional(v.number()),
      textMatch: v.optional(v.string()),
      epsgCodeMatch: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
    })
  ),
});

export const vNtripSettingsListData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      InternetUrl: v.optional(v.string()),
      InternetPort: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
      StartIndex: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
      PageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
    })
  ),
});

/**
 * OK
 */
export const vNtripSettingsListResponse =
  vConnectMapsWebApiDtosResponsesGeoRealtimeCorrectionNtripSettings;

export const vListRegionsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      regionName: v.optional(v.string()),
    })
  ),
});

export const vGetSensorsData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vStyleListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vStyleListResponse = vConnectMapsWebApiDtosResponsesGeoStyles;

export const vStylePostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostStyleRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vStylePostResponse = vConnectMapsWebApiDtosResponsesGeoStyle;

export const vStyleDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vStyleGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vStyleGetResponse = vConnectMapsWebApiDtosResponsesGeoStyle;

export const vStylePutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutStyleRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vStylePutResponse = vConnectMapsWebApiDtosResponsesGeoStyle;

export const vSupportedColorsListData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vSupportedColorsListResponse = v.array(v.string());

export const vStyleOverridePostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostStyleOverrideRequest),
  path: v.object({
    styleId: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vStyleOverridePostResponse =
  vConnectMapsWebApiDtosResponsesGeoStyleOverrides;

export const vStyleOverridesPostData = v.object({
  body: v.optional(
    v.array(vConnectMapsWebApiDtosRequestsGeoPostStyleOverrideRequest)
  ),
  path: v.object({
    styleId: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vStyleOverridesPostResponse =
  vConnectMapsWebApiDtosResponsesGeoStyleOverrides;

export const vStyleOverrideDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vStyleOverrideGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vStyleOverrideGetResponse =
  vConnectMapsWebApiDtosResponsesGeoStyleOverride;

export const vStyleOverridePutByIdData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutStyleOverrideRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vStyleOverridePutByIdResponse =
  vConnectMapsWebApiDtosResponsesGeoStyleOverride;

export const vStyleOverridePutData = v.object({
  body: v.optional(
    v.array(vConnectMapsWebApiDtosRequestsGeoPutStyleOverrideRequest)
  ),
  path: v.object({
    styleId: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vStyleOverridePutResponse =
  vConnectMapsWebApiDtosResponsesGeoStyleOverride;

export const vStyleOverrideListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vStyleOverrideListResponse =
  vConnectMapsWebApiDtosResponsesGeoStyleOverrides;

export const vSurveyJobPostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsSurveyJobGeoPostSurveyJobRequest
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vSurveyJobPostResponse =
  vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJob;

export const vSurveyJobGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeAttachments: v.optional(v.boolean(), false),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vSurveyJobGetResponse =
  vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJob;

export const vSurveyJobPatchData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsSurveyJobGeoPatchSurveyJobRequest
  ),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vSurveyJobPatchResponse =
  vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJob;

export const vSurveyJobQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      fields: v.optional(v.string()),
      pageIndex: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        0
      ),
      pageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        25
      ),
      includeAttachments: v.optional(v.boolean(), false),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
});

/**
 * OK
 */
export const vSurveyJobQueryResponse =
  vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobs;

export const vSurveyJobGetAttachmentsData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeDownloadUrl: v.optional(v.boolean(), false),
    })
  ),
});

/**
 * OK
 */
export const vSurveyJobGetAttachmentsResponse =
  vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobAttachments;

export const vSurveyJobGetLinkedFilesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeDownloadUrl: v.optional(v.boolean(), false),
    })
  ),
});

/**
 * OK
 */
export const vSurveyJobGetLinkedFilesResponse =
  vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobAttachments;

export const vSurveyJobGetFilesData = v.object({
  body: v.optional(v.array(v.string())),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeDownloadUrl: v.optional(v.boolean(), false),
    })
  ),
});

/**
 * OK
 */
export const vSurveyJobGetFilesResponse =
  vConnectMapsWebApiDtosResponsesSurveyJobGeoSurveyJobAttachments;

export const vSurveyJobDownloadPackageData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vSymbolListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vSymbolListResponse = vConnectMapsWebApiDtosResponsesGeoSymbols;

export const vSymbolPostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostSymbolRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vSymbolPostResponse = vConnectMapsWebApiDtosResponsesGeoSymbol;

export const vSymbolDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vSymbolGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vSymbolGetResponse = vConnectMapsWebApiDtosResponsesGeoSymbol;

export const vSymbolPutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutSymbolRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vSymbolPutResponse = vConnectMapsWebApiDtosResponsesGeoSymbol;

export const vSymbolDefinitionsListData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vSymbolDefinitionsListResponse =
  vConnectMapsWebApiDtosResponsesGeoSymbolDefinitions;

export const vGetMigrationJobData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vStartMigrationData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vStartMigrationResponse = vConnectMapsWebApiDtosGeoBackgroundJob;

export const vTemplateListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      workspaceId: v.optional(v.string()),
      name: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      minified: v.optional(v.boolean()),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateListResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplates;

export const vTemplatePostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostTemplateRequest),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vTemplatePostResponse = vConnectMapsWebApiDtosResponsesGeoTemplate;

export const vTemplateDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vTemplateGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      allInSeries: v.optional(v.boolean(), false),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateGetResponse = vConnectMapsWebApiDtosResponsesGeoTemplate;

export const vTemplatePutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutTemplateRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vTemplatePutResponse = vConnectMapsWebApiDtosResponsesGeoTemplate;

export const vTemplateGetLatestPublishedSeriesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      seriesIds: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateGetLatestPublishedSeriesResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplates;

export const vTemplateGetSeriesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    seriesId: v.pipe(v.string(), v.uuid()),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateGetSeriesResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplates;

export const vTemplateGetLatestSeriesData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    seriesId: v.pipe(v.string(), v.uuid()),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateGetLatestSeriesResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplate;

export const vTemplateGetDeltasData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      seriesId: v.optional(v.pipe(v.string(), v.uuid())),
      lowerVersion: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
    })
  ),
});

/**
 * OK
 */
export const vTemplateGetDeltasResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplateDeltas;

export const vTemplateGetLatestPublishedData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      workspaceId: v.optional(v.string()),
      includeLockedLayers: v.optional(v.boolean(), false),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateGetLatestPublishedResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplates;

export const vTemplateQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      minified: v.optional(v.boolean()),
      bringLatestVersionOnly: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateQueryResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplates;

export const vBatchTemplateGetDeltasData = v.object({
  body: v.optional(
    v.array(
      vConnectMapsWebApiDtosRequestsGeoBatchParametersRequest1ConnectMapsWebApiDtosRequestsGeoGetTemplateDeltasRequest_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null
    )
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vBatchTemplateGetDeltasResponse =
  vConnectMapsWebApiDtosResponsesGeoBatchResponses1ConnectMapsWebApiDtosResponsesGeoTemplates_ConnectMapsWebApiDtOs_Version_1000_Culture_neutral_PublicKeyToken_null;

export const vTemplateRelationshipsGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      workspaceId: v.optional(v.string()),
      seriesId: v.optional(v.pipe(v.string(), v.uuid())),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateRelationshipsGetResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplateRelationships;

export const vTemplateRelationshipsCreateData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostTemplateRelationshipRequest
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplateRelationshipsCreateResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplate;

export const vTemplatePublicationPostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostTemplatePublicationRequest
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vTemplatePublicationPostResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplatePublication;

export const vTemplatePublicationQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      excludes: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vTemplatePublicationQueryResponse =
  vConnectMapsWebApiDtosResponsesGeoTemplatePublications;

export const vTrimbleDataGetData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

export const vTrimbleDataGetGeocodeData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      query: v.optional(v.string()),
      maxResults: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        10
      ),
    })
  ),
});

export const vUserSettingsGetByTypeData = v.object({
  body: v.optional(v.never()),
  path: v.optional(v.never()),
  query: v.optional(
    v.object({
      type: v.optional(v.string()),
      name: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vUserSettingsGetByTypeResponse =
  vConnectMapsWebApiDtosResponsesGeoUserSettingses;

export const vUserSettingsPostData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPostUserSettingsRequest),
  path: v.optional(v.never()),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vUserSettingsPostResponse =
  vConnectMapsWebApiDtosResponsesGeoUserSettings;

export const vUserSettingsDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
  }),
  query: v.optional(v.never()),
});

export const vUserSettingsGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vUserSettingsGetResponse =
  vConnectMapsWebApiDtosResponsesGeoUserSettings;

export const vUserSettingsPutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutUserSettingsRequest),
  path: v.object({
    id: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vUserSettingsPutResponse =
  vConnectMapsWebApiDtosResponsesGeoUserSettings;

export const vWorkspaceListData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      type: v.optional(vConnectMapsWebApiDtosEnumsGeoWorkspaceType),
      name: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      includeResourceUris: v.optional(v.boolean()),
      includeLayers: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceListResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspaces;

export const vWorkspacePostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostWorkspaceRequestWritable
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * Created
 */
export const vWorkspacePostResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      deleteRelationship: v.optional(v.boolean(), false),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vWorkspaceGetData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      returnLayers: v.optional(v.boolean(), false),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceGetResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspacePatchData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPatchWorkspaceRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspacePatchResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspacePutData = v.object({
  body: v.optional(vConnectMapsWebApiDtosRequestsGeoPutWorkspaceRequest),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspacePutResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceGetViewerData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceGetViewerResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceGetSurveyData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceGetSurveyResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceGetByFileIdData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    fileId: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceGetByFileIdResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceGetImageData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      width: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        0
      ),
      height: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        ),
        0
      ),
      resizeMethod: v.optional(vConnectMapsWebApiDtosGeoResizeMethodType),
      fetchAreaImage: v.optional(v.boolean(), false),
    })
  ),
  headers: v.optional(
    v.object({
      'If-None-Match': v.optional(v.string()),
      'If-Modified-Since': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceGetImageResponse = v.string();

export const vWorkspacePutImageData = v.object({
  body: v.optional(
    v.object({
      file: v.optional(v.string()),
    })
  ),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      uploadWorkspaceAreaImage: v.optional(v.boolean(), false),
    })
  ),
});

export const vWorkspaceRestoreData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vWorkspaceRestoreResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceRelationshipsDeleteData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      childId: v.optional(v.string()),
      relationshipType: v.optional(v.string()),
    })
  ),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

export const vWorkspaceRelationshipsPatchData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPatchWorkspaceRelationshipsRequest
  ),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceRelationshipsPatchResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceRelationshipsUpdateData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPutWorkspaceRelationshipsRequest
  ),
  path: v.object({
    id: v.string(),
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
  headers: v.optional(
    v.object({
      'If-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceRelationshipsUpdateResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceListOrphanData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      startIndex: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
      pageSize: v.optional(
        v.pipe(
          v.number(),
          v.integer(),
          v.minValue(
            -2147483648,
            'Invalid value: Expected int32 to be >= -2^31'
          ),
          v.maxValue(
            2147483647,
            'Invalid value: Expected int32 to be <= 2^31-1'
          )
        )
      ),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceListOrphanResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspaces;

export const vWorkspaceQueryData = v.object({
  body: v.optional(v.never()),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(
    v.object({
      filter: v.optional(v.string()),
      sortBy: v.optional(v.string()),
      deletedItems: v.optional(v.boolean(), false),
      includeResourceUris: v.optional(v.boolean()),
      includeLayers: v.optional(v.boolean()),
    })
  ),
  headers: v.optional(
    v.object({
      Range: v.optional(v.string()),
      'If-None-Match': v.optional(v.string()),
    })
  ),
});

/**
 * OK
 */
export const vWorkspaceQueryResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspaces;

export const vWorkspaceDuplicatePostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostDuplicateWorkspaceRequestWritable
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vWorkspaceDuplicatePostResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;

export const vWorkspaceImportPostData = v.object({
  body: v.optional(
    vConnectMapsWebApiDtosRequestsGeoPostImportWorkspaceRequestWritable
  ),
  path: v.object({
    projectId: v.string(),
  }),
  query: v.optional(v.never()),
});

/**
 * OK
 */
export const vWorkspaceImportPostResponse =
  vConnectMapsWebApiDtosResponsesGeoWorkspace;
